import {Units} from '../../../../components/Forms/Constants/CommonESGConstants/constants';
import {
  Principle1Key,
  Principle1Label,
  Principle2Key,
  Principle2Label,
  Principle3Key,
  Principle3Label,
  Principle4Key,
  Principle4Label,
  Principle5Key,
  Principle5Label,
  Principle6Key,
  Principle6Label,
  Principle7Key,
  Principle7Label,
  Principle8Key,
  Principle8Label,
  Principle9Key,
  Principle9Label
} from '../../../../components/Forms/Constants/PrincipleWisePerformanceDisclosure/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';
import {calculateSum} from '../commonFunctions';

/* eslint-disable max-len */
export const principle1TabQuestions = [
  {
    key: '1',
    label: Principle1Label.P1_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_1,
            fieldLabel: Principle1Label.P1_LABEL_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_2,
            fieldLabel: Principle1Label.P1_LABEL_2,
            colSpan: true
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_3,
            fieldLabel: Principle1Label.P1_LABEL_3,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_4,
            fieldLabel: Principle1Label.P1_LABEL_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_5,
            fieldLabel: Principle1Label.P1_LABEL_2,
            colSpan: true
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_6,
            fieldLabel: Principle1Label.P1_LABEL_3,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_7,
            fieldLabel: Principle1Label.P1_LABEL_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_8,
            fieldLabel: Principle1Label.P1_LABEL_2,
            colSpan: true
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_9,
            fieldLabel: Principle1Label.P1_LABEL_3,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_10,
            fieldLabel: Principle1Label.P1_LABEL_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_11,
            fieldLabel: Principle1Label.P1_LABEL_2,
            colSpan: true
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_12,
            fieldLabel: Principle1Label.P1_LABEL_3,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_2
          },

          {
            fieldType: inputType.HEADING_2,
            heading: Principle1Label.P1_HEADING_5
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_13,
            fieldLabel: Principle1Label.P1_LABEL_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_14,
            fieldLabel: Principle1Label.P1_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_15,
            fieldLabel: Principle1Label.P1_LABEL_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_16,
            fieldLabel: Principle1Label.P1_LABEL_7
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle1Key.P1_QUESTION_17,
            fieldLabel: Principle1Label.P1_LABEL_8,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_7
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_18,
            fieldLabel: Principle1Label.P1_LABEL_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_19,
            fieldLabel: Principle1Label.P1_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_20,
            fieldLabel: Principle1Label.P1_LABEL_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_21,
            fieldLabel: Principle1Label.P1_LABEL_7
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle1Key.P1_QUESTION_22,
            fieldLabel: Principle1Label.P1_LABEL_8,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_8
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_23,
            fieldLabel: Principle1Label.P1_LABEL_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_24,
            fieldLabel: Principle1Label.P1_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_25,
            fieldLabel: Principle1Label.P1_LABEL_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_26,
            fieldLabel: Principle1Label.P1_LABEL_7
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle1Key.P1_QUESTION_27,
            fieldLabel: Principle1Label.P1_LABEL_8,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_2,
            heading: Principle1Label.P1_HEADING_9
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_10
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_28,
            fieldLabel: Principle1Label.P1_LABEL_9
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_29,
            fieldLabel: Principle1Label.P1_LABEL_10
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_30,
            fieldLabel: Principle1Label.P1_LABEL_11
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle1Key.P1_QUESTION_31,
            fieldLabel: Principle1Label.P1_LABEL_12,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_11
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_32,
            fieldLabel: Principle1Label.P1_LABEL_9
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_33,
            fieldLabel: Principle1Label.P1_LABEL_10
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle1Key.P1_QUESTION_34,
            fieldLabel: Principle1Label.P1_LABEL_11
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle1Key.P1_QUESTION_35,
            fieldLabel: Principle1Label.P1_LABEL_12,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_3
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle1Key.P1_QUESTION_91,
            formList: {
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle1Key.P1_QUESTION_36,
                  fieldLabel: Principle1Label.P1_LABEL_13,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle1Key.P1_QUESTION_37,
                  fieldLabel: Principle1Label.P1_LABEL_14,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_4
          },
          {
            fieldType: inputType.RADIOGROUP_P1_QUESTION_38,
            fieldName: Principle1Key.P1_QUESTION_38,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_5
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_39,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_40,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_41,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_42,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_43,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_44,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_45,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_46,
            fieldLabel: Principle1Label.P1_LABEL_16
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle1Label.P1_QUESTION_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle1Label.P1_HEADING_16
                },
                {
                  type: inputType.HEADING,
                  heading: Principle1Label.P1_HEADING_18
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle1Key.P1_QUESTION_47,
                  fieldLabel: Principle1Label.P1_LABEL_17
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle1Key.P1_QUESTION_48,
                  fieldLabel: Principle1Label.P1_LABEL_18
                },
                {
                  type: inputType.HEADING,
                  heading: Principle1Label.P1_HEADING_19
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle1Key.P1_QUESTION_49,
                  fieldLabel: Principle1Label.P1_LABEL_17
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle1Key.P1_QUESTION_50,
                  fieldLabel: Principle1Label.P1_LABEL_18
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle1Label.P1_HEADING_17
                },
                {
                  type: inputType.HEADING,
                  heading: Principle1Label.P1_HEADING_18
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle1Key.P1_QUESTION_51,
                  fieldLabel: Principle1Label.P1_LABEL_17
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle1Key.P1_QUESTION_52,
                  fieldLabel: Principle1Label.P1_LABEL_18
                },
                {
                  type: inputType.HEADING,
                  heading: Principle1Label.P1_HEADING_19
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle1Key.P1_QUESTION_53,
                  fieldLabel: Principle1Label.P1_LABEL_17
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle1Key.P1_QUESTION_54,
                  fieldLabel: Principle1Label.P1_LABEL_18
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_7
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_55,
            askAIkey: 'P1E_CORRUPTION_ACTIONS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_8
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_36
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_56_1,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_56_2,
            fieldLabel: Principle1Label.P1_LABEL_16
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_9
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_HEADING_20
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_23
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_57,
            fieldLabel: Principle1Label.P1_LABEL_15,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_58,
            fieldLabel: Principle1Label.P1_LABEL_16,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_24
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_59,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_60,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_25
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_61,
            fieldLabel: Principle1Label.P1_LABEL_15,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_62,
            fieldLabel: Principle1Label.P1_LABEL_16,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_HEADING_21
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_26
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_63,
            fieldLabel: Principle1Label.P1_LABEL_15,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_64,
            fieldLabel: Principle1Label.P1_LABEL_16,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_27
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_65,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_66,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_28
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_67,
            fieldLabel: Principle1Label.P1_LABEL_15,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_68,
            fieldLabel: Principle1Label.P1_LABEL_16,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_HEADING_22
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_29
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_69,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_70,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_30
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_71,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_72,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_31
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_73,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_74,
            fieldLabel: Principle1Label.P1_LABEL_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle1Label.P1_HEADING_32
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_75,
            fieldLabel: Principle1Label.P1_LABEL_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_76,
            fieldLabel: Principle1Label.P1_LABEL_16
          }
        ]
      }
    ]
  },

  {
    key: '2',
    label: Principle1Label.P1_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_10
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle1Key.P1_QUESTION_77,
            fieldLabel: Principle1Label.P1_LABEL_19
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle1Key.P1_QUESTION_78,
            fieldLabel: Principle1Label.P1_LABEL_20,
            askAIkey: 'P1L_VC_AWARENESS',
            colSpan: true
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle1Key.P1_QUESTION_79,
            fieldLabel: Principle1Label.P1_LABEL_21,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle1Label.P1_QUESTION_11
          },

          {
            fieldType: inputType.RADIOGROUP_P1_QUESTION_80,
            fieldName: Principle1Key.P1_QUESTION_80,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P1L_CONFLICT_MANAGEMENT'
          }
        ]
      }
    ]
  }
];

export const principle2TabQuestions = [
  {
    key: '1',
    label: Principle2Label.P2_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_4
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle2Key.P2_QUESTION_1,
            fieldLabel: Principle2Label.P2_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle2Key.P2_QUESTION_2,
            fieldLabel: Principle2Label.P2_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_3,
            fieldLabel: Principle2Label.P2_LABEL_3,
            colSpan: true,
            askAIkey: 'P2E_RND_CAPEX'
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_5
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle2Key.P2_QUESTION_4,
            fieldLabel: Principle2Label.P2_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle2Key.P2_QUESTION_5,
            fieldLabel: Principle2Label.P2_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_6,
            fieldLabel: Principle2Label.P2_LABEL_3,
            colSpan: true,
            askAIkey: 'P2E_RND_CAPEX'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_2
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_7,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P2E_SUSTAINABLE_SOURCING'
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_29
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle2Key.P2_QUESTION_8,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_3
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_6
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_9
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_7
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_10
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_8
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_11
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_9
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_12
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_4
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle2Key.P2_QUESTION_13,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle2Key.P2_QUESTION_63_1,
            askAIkey: 'P2E_EPR_APPLICABILITY'
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle2Label.P2_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_QUESTION_5
          },
          {
            fieldType: inputType.RADIOGROUP_YES_THEN_SHOW_TABLE,
            fieldName: Principle2Key.P2_QUESTION_14,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS_TOGGLE_TABLE,
            relatedKey: Principle2Key.P2_QUESTION_14,
            fieldName: Principle2Key.P2_QUESTION_14_1,
            triggerKey: 'Yes',
            formList: {
              name: 'entityConducted',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_15,
                  fieldLabel: Principle2Label.P2_HEADING_10
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_16,
                  fieldLabel: Principle2Label.P2_HEADING_11
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle2Key.P2_QUESTION_17,
                  fieldLabel: Principle2Label.P2_HEADING_12,
                  units: Units.percentage
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_18,
                  fieldLabel: Principle2Label.P2_HEADING_13
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle2Key.P2_QUESTION_19,
                  fieldLabel: Principle2Label.P2_HEADING_14,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName: Principle2Key.P2_QUESTION_20,
                  fieldLabel: Principle2Label.P2_HEADING_15,
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_QUESTION_6
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle2Key.P2_QUESTION_61,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_21,
                  fieldLabel: Principle2Label.P2_HEADING_16,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle2Key.P2_QUESTION_22,
                  fieldLabel: Principle2Label.P2_HEADING_17,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle2Key.P2_QUESTION_23,
                  fieldLabel: Principle2Label.P2_HEADING_18,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_7
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle2Key.P2_QUESTION_62,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_24,
                  fieldLabel: Principle2Label.P2_HEADING_19,
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle2Key.P2_QUESTION_25,
                  fieldLabel: Principle2Label.P2_HEADING_20,
                  units: Units.percentage,
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle2Key.P2_QUESTION_26,
                  fieldLabel: Principle2Label.P2_HEADING_21,
                  units: Units.percentage,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_QUESTION_8
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_22
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_27,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_28,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_29,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_30,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_31,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_32,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_23
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_33,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_34,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_35,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_36,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_37,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_38,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_24
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_39,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_40,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_41,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_42,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_43,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_44,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_HEADING_25
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_45,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_46,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_47,
            fieldLabel: Principle2Label.P2_LABEL_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle2Label.P2_LABEL_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_48,
            fieldLabel: Principle2Label.P2_LABEL_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_49,
            fieldLabel: Principle2Label.P2_LABEL_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle2Key.P2_QUESTION_50,
            fieldLabel: Principle2Label.P2_LABEL_6
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle2Label.P2_QUESTION_9
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle2Key.P2_QUESTION_63,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle2Key.P2_QUESTION_51,
                  fieldLabel: Principle2Label.P2_HEADING_26,
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle2Key.P2_QUESTION_52,
                  fieldLabel: Principle2Label.P2_HEADING_27,
                  units: Units.percentage,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const principle3TabQuestions = [
  {
    key: '1',
    label: Principle3Label.P3_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'p3question1aPermanentEmployees',
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_1
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_1,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_2,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_3,
                  fieldLabel: Principle3Label.P3_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_4,
                  fieldLabel: Principle3Label.P3_QUESTION_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_5,
                  fieldLabel: Principle3Label.P3_QUESTION_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_6,
                  fieldLabel: Principle3Label.P3_QUESTION_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_7,
                  fieldLabel: Principle3Label.P3_QUESTION_7
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_8,
                  fieldLabel: Principle3Label.P3_QUESTION_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_9,
                  fieldLabel: Principle3Label.P3_QUESTION_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_10,
                  fieldLabel: Principle3Label.P3_QUESTION_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_41,
                  fieldLabel: Principle3Label.P3_QUESTION_11,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_3
                  ],
                  formula: ([totalMale, maleWithHI]: any[]):
                    | number
                    | string => {
                    return (maleWithHI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_42,
                  fieldLabel: Principle3Label.P3_QUESTION_12,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_4
                  ],
                  formula: ([totalFemale, femaleWithHI]: any[]):
                    | number
                    | string => {
                    return (femaleWithHI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_43,
                  fieldLabel: Principle3Label.P3_QUESTION_13,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_5
                  ],
                  formula: ([totalMale, maleWithAI]: any[]):
                    | number
                    | string => {
                    return (maleWithAI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_44,
                  fieldLabel: Principle3Label.P3_QUESTION_14,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_6
                  ],
                  formula: ([totalFemale, femaleWithAI]: any[]):
                    | number
                    | string => {
                    return (femaleWithAI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_45,
                  fieldLabel: Principle3Label.P3_QUESTION_15,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_7
                  ],
                  formula: ([totalMale, maleWithPB]: any[]):
                    | number
                    | string => {
                    return (maleWithPB / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_46,
                  fieldLabel: Principle3Label.P3_QUESTION_16,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_8
                  ],
                  formula: ([totalFemale, femaleWithMB]: any[]):
                    | number
                    | string => {
                    return (femaleWithMB / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_463,
                  fieldLabel: Principle3Label.P3_QUESTION_17,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_9
                  ],
                  formula: ([totalMale, maleWithDCF]: any[]):
                    | number
                    | string => {
                    return (maleWithDCF / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_47,
                  fieldLabel: Principle3Label.P3_QUESTION_18,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_10
                  ],
                  formula: ([totalFemale, femaleWithDCF]: any[]):
                    | number
                    | string => {
                    return (femaleWithDCF / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_314,
                  fieldLabel: Principle3Label.P3_HEADING_24,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_315,
                  fieldLabel: Principle3Label.P3_QUESTION_152,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_3,
                    Principle3Key.P3_QUESTION_4
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_316,
                  fieldLabel: Principle3Label.P3_QUESTION_153,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_3,
                    Principle3Key.P3_QUESTION_4
                  ],
                  formula: ([totalMale, totalFemale, maleHI, femaleHI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalHI = maleHI + femaleHI;

                    return (totalHI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_317,
                  fieldLabel: Principle3Label.P3_QUESTION_154,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_5,
                    Principle3Key.P3_QUESTION_6
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_318,
                  fieldLabel: Principle3Label.P3_QUESTION_155,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_5,
                    Principle3Key.P3_QUESTION_6
                  ],
                  formula: ([totalMale, totalFemale, maleAI, femaleAI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalAI = maleAI + femaleAI;

                    return (totalAI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_319,
                  fieldLabel: Principle3Label.P3_QUESTION_156,
                  relatedKey: [Principle3Key.P3_QUESTION_7],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_320,
                  fieldLabel: Principle3Label.P3_QUESTION_157,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_7
                  ],
                  formula: ([totalMale, totalFemale, malePaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (malePaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_321,
                  fieldLabel: Principle3Label.P3_QUESTION_158,
                  relatedKey: [Principle3Key.P3_QUESTION_8],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_322,
                  fieldLabel: Principle3Label.P3_QUESTION_159,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_8
                  ],
                  formula: ([totalMale, totalFemale, femaleMaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (femaleMaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_323,
                  fieldLabel: Principle3Label.P3_QUESTION_160,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_9,
                    Principle3Key.P3_QUESTION_10
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_324,
                  fieldLabel: Principle3Label.P3_QUESTION_161,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_1,
                    Principle3Key.P3_QUESTION_2,
                    Principle3Key.P3_QUESTION_9,
                    Principle3Key.P3_QUESTION_10
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleDayCare,
                    femaleDayCare
                  ]: any[]): string | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalDayCare = maleDayCare + femaleDayCare;

                    return (totalDayCare / totalEmp) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'p3question1aOtherThanPermanentEmployees',
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_11,
                  fieldLabel: Principle3Label.P3_QUESTION_19
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_12,
                  fieldLabel: Principle3Label.P3_QUESTION_20
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_13,
                  fieldLabel: Principle3Label.P3_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_14,
                  fieldLabel: Principle3Label.P3_QUESTION_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_15,
                  fieldLabel: Principle3Label.P3_QUESTION_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_16,
                  fieldLabel: Principle3Label.P3_QUESTION_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_17,
                  fieldLabel: Principle3Label.P3_QUESTION_7
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_18,
                  fieldLabel: Principle3Label.P3_QUESTION_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_19,
                  fieldLabel: Principle3Label.P3_QUESTION_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_20,
                  fieldLabel: Principle3Label.P3_QUESTION_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_258,
                  fieldLabel: Principle3Label.P3_QUESTION_11,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_13
                  ],
                  formula: ([totalMale, maleWithHI]: any[]):
                    | number
                    | string => {
                    return (maleWithHI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_259,
                  fieldLabel: Principle3Label.P3_QUESTION_12,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_14
                  ],
                  formula: ([totalFemale, femaleWithHI]: any[]):
                    | number
                    | string => {
                    return (femaleWithHI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_260,
                  fieldLabel: Principle3Label.P3_QUESTION_13,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_15
                  ],
                  formula: ([totalMale, maleWithAI]: any[]):
                    | number
                    | string => {
                    return (maleWithAI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_261,
                  fieldLabel: Principle3Label.P3_QUESTION_14,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_16
                  ],
                  formula: ([totalFemale, femaleWithAI]: any[]):
                    | number
                    | string => {
                    return (femaleWithAI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_262,
                  fieldLabel: Principle3Label.P3_QUESTION_15,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_17
                  ],
                  formula: ([totalMale, maleWithPB]: any[]):
                    | number
                    | string => {
                    return (maleWithPB / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_263,
                  fieldLabel: Principle3Label.P3_QUESTION_16,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_18
                  ],
                  formula: ([totalFemale, femaleWithMB]: any[]):
                    | number
                    | string => {
                    return (femaleWithMB / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_264,
                  fieldLabel: Principle3Label.P3_QUESTION_17,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_19
                  ],
                  formula: ([totalMale, maleWithDCF]: any[]):
                    | number
                    | string => {
                    return (maleWithDCF / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_265,
                  fieldLabel: Principle3Label.P3_QUESTION_18,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_20
                  ],
                  formula: ([totalFemale, femaleWithDCF]: any[]):
                    | number
                    | string => {
                    return (femaleWithDCF / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_325,
                  fieldLabel: Principle3Label.P3_HEADING_22,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_326,
                  fieldLabel: Principle3Label.P3_QUESTION_152,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_13,
                    Principle3Key.P3_QUESTION_14
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_327,
                  fieldLabel: Principle3Label.P3_QUESTION_153,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_13,
                    Principle3Key.P3_QUESTION_14
                  ],
                  formula: ([totalMale, totalFemale, maleHI, femaleHI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalHI = maleHI + femaleHI;

                    return (totalHI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_328,
                  fieldLabel: Principle3Label.P3_QUESTION_154,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_15,
                    Principle3Key.P3_QUESTION_16
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_329,
                  fieldLabel: Principle3Label.P3_QUESTION_155,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_15,
                    Principle3Key.P3_QUESTION_16
                  ],
                  formula: ([totalMale, totalFemale, maleAI, femaleAI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalAI = maleAI + femaleAI;

                    return (totalAI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_330,
                  fieldLabel: Principle3Label.P3_QUESTION_156,
                  relatedKey: [Principle3Key.P3_QUESTION_17],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_331,
                  fieldLabel: Principle3Label.P3_QUESTION_157,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_17
                  ],
                  formula: ([totalMale, totalFemale, malePaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (malePaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_332,
                  fieldLabel: Principle3Label.P3_QUESTION_158,
                  relatedKey: [Principle3Key.P3_QUESTION_18],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_333,
                  fieldLabel: Principle3Label.P3_QUESTION_159,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_18
                  ],
                  formula: ([totalMale, totalFemale, femaleMaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (femaleMaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_334,
                  fieldLabel: Principle3Label.P3_QUESTION_160,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_19,
                    Principle3Key.P3_QUESTION_20
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_335,
                  fieldLabel: Principle3Label.P3_QUESTION_161,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_11,
                    Principle3Key.P3_QUESTION_12,
                    Principle3Key.P3_QUESTION_19,
                    Principle3Key.P3_QUESTION_20
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleDayCare,
                    femaleDayCare
                  ]: any[]): string | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalDayCare = maleDayCare + femaleDayCare;

                    return (totalDayCare / totalEmp) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'p3question1aPermanentWorkers',
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_4
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_48,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_49,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_50,
                  fieldLabel: Principle3Label.P3_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_51,
                  fieldLabel: Principle3Label.P3_QUESTION_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_52,
                  fieldLabel: Principle3Label.P3_QUESTION_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_53,
                  fieldLabel: Principle3Label.P3_QUESTION_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_54,
                  fieldLabel: Principle3Label.P3_QUESTION_7
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_55,
                  fieldLabel: Principle3Label.P3_QUESTION_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_56,
                  fieldLabel: Principle3Label.P3_QUESTION_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_57,
                  fieldLabel: Principle3Label.P3_QUESTION_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_58,
                  fieldLabel: Principle3Label.P3_QUESTION_11,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_50
                  ],
                  formula: ([totalMale, maleWithHI]: any[]):
                    | number
                    | string => {
                    return (maleWithHI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_59,
                  fieldLabel: Principle3Label.P3_QUESTION_12,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_51
                  ],
                  formula: ([totalFemale, femaleWithHI]: any[]):
                    | number
                    | string => {
                    return (femaleWithHI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_60,
                  fieldLabel: Principle3Label.P3_QUESTION_13,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_52
                  ],
                  formula: ([totalMale, maleWithAI]: any[]):
                    | number
                    | string => {
                    return (maleWithAI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_61,
                  fieldLabel: Principle3Label.P3_QUESTION_14,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_53
                  ],
                  formula: ([totalFemale, femaleWithAI]: any[]):
                    | number
                    | string => {
                    return (femaleWithAI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_62,
                  fieldLabel: Principle3Label.P3_QUESTION_15,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_54
                  ],
                  formula: ([totalMale, maleWithPB]: any[]):
                    | number
                    | string => {
                    return (maleWithPB / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_63,
                  fieldLabel: Principle3Label.P3_QUESTION_16,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_55
                  ],
                  formula: ([totalFemale, femaleWithMB]: any[]):
                    | number
                    | string => {
                    return (femaleWithMB / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_64,
                  fieldLabel: Principle3Label.P3_QUESTION_17,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_56
                  ],
                  formula: ([totalMale, maleWithDCF]: any[]):
                    | number
                    | string => {
                    return (maleWithDCF / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_65,
                  fieldLabel: Principle3Label.P3_QUESTION_18,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_57
                  ],
                  formula: ([totalFemale, femaleWithDCF]: any[]):
                    | number
                    | string => {
                    return (femaleWithDCF / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_336,
                  fieldLabel: Principle3Label.P3_HEADING_25,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_337,
                  fieldLabel: Principle3Label.P3_QUESTION_162,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_50,
                    Principle3Key.P3_QUESTION_51
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_338,
                  fieldLabel: Principle3Label.P3_QUESTION_163,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_50,
                    Principle3Key.P3_QUESTION_51
                  ],
                  formula: ([totalMale, totalFemale, maleHI, femaleHI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalHI = maleHI + femaleHI;

                    return (totalHI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_339,
                  fieldLabel: Principle3Label.P3_QUESTION_164,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_52,
                    Principle3Key.P3_QUESTION_53
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_340,
                  fieldLabel: Principle3Label.P3_QUESTION_165,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_52,
                    Principle3Key.P3_QUESTION_53
                  ],
                  formula: ([totalMale, totalFemale, maleAI, femaleAI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalAI = maleAI + femaleAI;

                    return (totalAI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_341,
                  fieldLabel: Principle3Label.P3_QUESTION_166,
                  relatedKey: [Principle3Key.P3_QUESTION_54],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_342,
                  fieldLabel: Principle3Label.P3_QUESTION_167,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_54
                  ],
                  formula: ([totalMale, totalFemale, malePaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (malePaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_343,
                  fieldLabel: Principle3Label.P3_QUESTION_168,
                  relatedKey: [Principle3Key.P3_QUESTION_55],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_344,
                  fieldLabel: Principle3Label.P3_QUESTION_169,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_55
                  ],
                  formula: ([totalMale, totalFemale, femaleMaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (femaleMaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_345,
                  fieldLabel: Principle3Label.P3_QUESTION_170,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_56,
                    Principle3Key.P3_QUESTION_57
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_346,
                  fieldLabel: Principle3Label.P3_QUESTION_171,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_48,
                    Principle3Key.P3_QUESTION_49,
                    Principle3Key.P3_QUESTION_56,
                    Principle3Key.P3_QUESTION_57
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleDayCare,
                    femaleDayCare
                  ]: any[]): string | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalDayCare = maleDayCare + femaleDayCare;

                    return (totalDayCare / totalEmp) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'p3question1aOtherThanPermanentWorkers',
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_66,
                  fieldLabel: Principle3Label.P3_QUESTION_23
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_67,
                  fieldLabel: Principle3Label.P3_QUESTION_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_68,
                  fieldLabel: Principle3Label.P3_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_69,
                  fieldLabel: Principle3Label.P3_QUESTION_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_70,
                  fieldLabel: Principle3Label.P3_QUESTION_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_71,
                  fieldLabel: Principle3Label.P3_QUESTION_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_72,
                  fieldLabel: Principle3Label.P3_QUESTION_7
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_73,
                  fieldLabel: Principle3Label.P3_QUESTION_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_74,
                  fieldLabel: Principle3Label.P3_QUESTION_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_75,
                  fieldLabel: Principle3Label.P3_QUESTION_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_76,
                  fieldLabel: Principle3Label.P3_QUESTION_11,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_68
                  ],
                  formula: ([totalMale, maleWithHI]: any[]):
                    | number
                    | string => {
                    return (maleWithHI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_77,
                  fieldLabel: Principle3Label.P3_QUESTION_12,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_69
                  ],
                  formula: ([totalFemale, femaleWithHI]: any[]):
                    | number
                    | string => {
                    return (femaleWithHI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_78,
                  fieldLabel: Principle3Label.P3_QUESTION_13,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_70
                  ],
                  formula: ([totalMale, maleWithAI]: any[]):
                    | number
                    | string => {
                    return (maleWithAI / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_79,
                  fieldLabel: Principle3Label.P3_QUESTION_14,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_71
                  ],
                  formula: ([totalFemale, femaleWithAI]: any[]):
                    | number
                    | string => {
                    return (femaleWithAI / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_80,
                  fieldLabel: Principle3Label.P3_QUESTION_15,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_72
                  ],
                  formula: ([totalMale, maleWithPB]: any[]):
                    | number
                    | string => {
                    return (maleWithPB / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_81,
                  fieldLabel: Principle3Label.P3_QUESTION_16,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_73
                  ],
                  formula: ([totalFemale, femaleWithMB]: any[]):
                    | number
                    | string => {
                    return (femaleWithMB / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_82,
                  fieldLabel: Principle3Label.P3_QUESTION_17,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_74
                  ],
                  formula: ([totalMale, maleWithDCF]: any[]):
                    | number
                    | string => {
                    return (maleWithDCF / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_83,
                  fieldLabel: Principle3Label.P3_QUESTION_18,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_75
                  ],
                  formula: ([totalFemale, femaleWithDCF]: any[]):
                    | number
                    | string => {
                    return (femaleWithDCF / totalFemale) * 100;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_347,
                  fieldLabel: Principle3Label.P3_HEADING_23,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_348,
                  fieldLabel: Principle3Label.P3_QUESTION_162,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_68,
                    Principle3Key.P3_QUESTION_69
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_349,
                  fieldLabel: Principle3Label.P3_QUESTION_163,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_68,
                    Principle3Key.P3_QUESTION_69
                  ],
                  formula: ([totalMale, totalFemale, maleHI, femaleHI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalHI = maleHI + femaleHI;

                    return (totalHI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_350,
                  fieldLabel: Principle3Label.P3_QUESTION_164,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_70,
                    Principle3Key.P3_QUESTION_71
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_351,
                  fieldLabel: Principle3Label.P3_QUESTION_165,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_70,
                    Principle3Key.P3_QUESTION_71
                  ],
                  formula: ([totalMale, totalFemale, maleAI, femaleAI]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalAI = maleAI + femaleAI;

                    return (totalAI / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_352,
                  fieldLabel: Principle3Label.P3_QUESTION_166,
                  relatedKey: [Principle3Key.P3_QUESTION_72],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_353,
                  fieldLabel: Principle3Label.P3_QUESTION_167,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_72
                  ],
                  formula: ([totalMale, totalFemale, malePaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (malePaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_354,
                  fieldLabel: Principle3Label.P3_QUESTION_168,
                  relatedKey: [Principle3Key.P3_QUESTION_73],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_355,
                  fieldLabel: Principle3Label.P3_QUESTION_169,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_73
                  ],
                  formula: ([totalMale, totalFemale, femaleMaternity]: any[]):
                    | string
                    | number => {
                    const totalEmp = totalMale + totalFemale;

                    return (femaleMaternity / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_356,
                  fieldLabel: Principle3Label.P3_QUESTION_170,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_74,
                    Principle3Key.P3_QUESTION_75
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_357,
                  fieldLabel: Principle3Label.P3_QUESTION_171,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_66,
                    Principle3Key.P3_QUESTION_67,
                    Principle3Key.P3_QUESTION_74,
                    Principle3Key.P3_QUESTION_75
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleDayCare,
                    femaleDayCare
                  ]: any[]): string | number => {
                    const totalEmp = totalMale + totalFemale;
                    const totalDayCare = maleDayCare + femaleDayCare;

                    return (totalDayCare / totalEmp) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_7
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_8
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_84,
            fieldLabel: Principle3Label.P3_QUESTION_25,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_85,
            fieldLabel: Principle3Label.P3_QUESTION_26,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_9
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_12
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_13
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_389,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_390,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_86,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_87,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_88,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_294,
                  fieldLabel: Principle3Label.P3_QUESTION_148,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_389,
                    Principle3Key.P3_QUESTION_86
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_295,
                  fieldLabel: Principle3Label.P3_QUESTION_149,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_390,
                    Principle3Key.P3_QUESTION_87
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_391,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_392,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_89,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_90,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_91,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_296,
                  fieldLabel: Principle3Label.P3_QUESTION_150,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_391,
                    Principle3Key.P3_QUESTION_89
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_297,
                  fieldLabel: Principle3Label.P3_QUESTION_151,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_392,
                    Principle3Key.P3_QUESTION_90
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_14
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_393,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_394,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_284,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_285,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_286,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_298,
                  fieldLabel: Principle3Label.P3_QUESTION_148,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_393,
                    Principle3Key.P3_QUESTION_284
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_299,
                  fieldLabel: Principle3Label.P3_QUESTION_149,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_394,
                    Principle3Key.P3_QUESTION_285
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_395,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_396,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_287,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_288,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_289,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_300,
                  fieldLabel: Principle3Label.P3_QUESTION_150,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_395,
                    Principle3Key.P3_QUESTION_287
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_301,
                  fieldLabel: Principle3Label.P3_QUESTION_151,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_396,
                    Principle3Key.P3_QUESTION_288
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_15
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_397,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_398,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_92,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_93,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_94,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_302,
                  fieldLabel: Principle3Label.P3_QUESTION_148,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_397,
                    Principle3Key.P3_QUESTION_92
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_303,
                  fieldLabel: Principle3Label.P3_QUESTION_149,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_398,
                    Principle3Key.P3_QUESTION_93
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_399,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_400,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_362,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_363,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_364,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  defaultValue: 'Yes',
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_304,
                  fieldLabel: Principle3Label.P3_QUESTION_150,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_399,
                    Principle3Key.P3_QUESTION_362
                  ],
                  formula: ([totalWorkers, empCovered]: any[]):
                    | string
                    | number => {
                    return (empCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_305,
                  fieldLabel: Principle3Label.P3_QUESTION_151,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_400,
                    Principle3Key.P3_QUESTION_363
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_18
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle3Key.P3_QUESTION_361,
                  placeHolder: 'Others - please specify'
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_401,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_402,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_365,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_366,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_290,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_306,
                  fieldLabel: Principle3Label.P3_QUESTION_148,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_401,
                    Principle3Key.P3_QUESTION_365
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_307,
                  fieldLabel: Principle3Label.P3_QUESTION_149,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_402,
                    Principle3Key.P3_QUESTION_366
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_403,
                  fieldLabel: Principle3Label.P3_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_404,
                  fieldLabel: Principle3Label.P3_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_291,
                  fieldLabel: Principle3Label.P3_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_292,
                  fieldLabel: Principle3Label.P3_QUESTION_28
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle3Key.P3_QUESTION_293,
                  fieldLabel: Principle3Label.P3_QUESTION_29,
                  colSpan: true,
                  defaultValue: 'Yes',
                  options: ['Yes', 'No', 'N/A']
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_308,
                  fieldLabel: Principle3Label.P3_QUESTION_150,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_403,
                    Principle3Key.P3_QUESTION_291
                  ],
                  formula: ([totalEmp, empCovered]: any[]): string | number => {
                    return (empCovered / totalEmp) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_309,
                  fieldLabel: Principle3Label.P3_QUESTION_151,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_404,
                    Principle3Key.P3_QUESTION_292
                  ],
                  formula: ([totalWorkers, workersCovered]: any[]):
                    | string
                    | number => {
                    return (workersCovered / totalWorkers) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_19
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_49
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_98,
            askAIkey: 'P3E_ACCESSIBILITY'
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_50
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_99,
            askAIkey: 'P3E_EQUAL_OPPORTUNITY'
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_51
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: ' returnToWorkAndRetentionRatesOfPermanentEmployeesBeing',
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_101,
                  fieldLabel: Principle3Label.P3_QUESTION_34
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_102,
                  fieldLabel: Principle3Label.P3_QUESTION_35
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_103,
                  fieldLabel: Principle3Label.P3_QUESTION_36
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_104,
                  fieldLabel: Principle3Label.P3_QUESTION_37
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_109,
                  fieldLabel: Principle3Label.P3_QUESTION_38,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_101,
                    Principle3Key.P3_QUESTION_102,
                    Principle3Key.P3_QUESTION_103,
                    Principle3Key.P3_QUESTION_104
                  ],
                  formula: ([
                    didReturnMale,
                    didReturnFemale,
                    dueReturnMale,
                    dueReturnFemale
                  ]: any[]): string | number => {
                    const totalDidReturn = didReturnMale + didReturnFemale;
                    const totalDueReturn = dueReturnMale + dueReturnFemale;

                    return (totalDidReturn / totalDueReturn) * 100;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_270,
                  fieldLabel: Principle3Label.P3_QUESTION_39,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_101,
                    Principle3Key.P3_QUESTION_103
                  ],
                  formula: ([didReturn, dueReturn]: any[]): string | number => {
                    return (didReturn / dueReturn) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_110,
                  fieldLabel: Principle3Label.P3_QUESTION_40,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_102,
                    Principle3Key.P3_QUESTION_104
                  ],
                  formula: ([didReturn, dueReturn]: any[]): string | number => {
                    return (didReturn / dueReturn) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: ' returnToWorkAndRetentionRatesOfPermanentEmployeesBeing',
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_266,
                  fieldLabel: Principle3Label.P3_QUESTION_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_267,
                  fieldLabel: Principle3Label.P3_QUESTION_42
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_268,
                  fieldLabel: Principle3Label.P3_QUESTION_128
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_269,
                  fieldLabel: Principle3Label.P3_QUESTION_129
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_271,
                  fieldLabel: Principle3Label.P3_QUESTION_130,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_266,
                    Principle3Key.P3_QUESTION_267,
                    Principle3Key.P3_QUESTION_268,
                    Principle3Key.P3_QUESTION_269
                  ],
                  formula: ([
                    followingPeriodMale,
                    followingPeriodFemale,
                    priorPeriodMale,
                    priorPeriodFemale
                  ]: any[]): string | number => {
                    const totalFollowingPeriod =
                      followingPeriodMale + followingPeriodFemale;
                    const totalPriorPeriod =
                      priorPeriodMale + priorPeriodFemale;

                    return (totalFollowingPeriod / totalPriorPeriod) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_272,
                  fieldLabel: Principle3Label.P3_QUESTION_131,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_266,
                    Principle3Key.P3_QUESTION_268
                  ],
                  formula: ([followingPeriodMale, priorPeriodMale]: any[]):
                    | string
                    | number => {
                    return (followingPeriodMale / priorPeriodMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_273,
                  fieldLabel: Principle3Label.P3_QUESTION_132,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_267,
                    Principle3Key.P3_QUESTION_269
                  ],
                  formula: ([followingPeriodFemale, priorPeriodFemale]: any[]):
                    | string
                    | number => {
                    return (followingPeriodFemale / priorPeriodFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'returnToWorkAndRetentionRatesOfPermanentWorkersBeing',
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_105,
                  fieldLabel: Principle3Label.P3_QUESTION_134
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_106,
                  fieldLabel: Principle3Label.P3_QUESTION_135
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_107,
                  fieldLabel: Principle3Label.P3_QUESTION_136
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_108,
                  fieldLabel: Principle3Label.P3_QUESTION_137
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_278,
                  fieldLabel: Principle3Label.P3_QUESTION_138,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_105,
                    Principle3Key.P3_QUESTION_106,
                    Principle3Key.P3_QUESTION_107,
                    Principle3Key.P3_QUESTION_108
                  ],
                  formula: ([
                    didReturnMale,
                    didReturnFemale,
                    dueReturnMale,
                    dueReturnFemale
                  ]: any[]): string | number => {
                    const totalDidReturn = didReturnMale + didReturnFemale;
                    const totalDueReturn = dueReturnMale + dueReturnFemale;

                    return (totalDidReturn / totalDueReturn) * 100;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_279,
                  fieldLabel: Principle3Label.P3_QUESTION_139,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_105,
                    Principle3Key.P3_QUESTION_107
                  ],
                  formula: ([didReturn, dueReturn]: any[]): string | number => {
                    return (didReturn / dueReturn) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_280,
                  fieldLabel: Principle3Label.P3_QUESTION_140,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_106,
                    Principle3Key.P3_QUESTION_108
                  ],
                  formula: ([didReturn, dueReturn]: any[]): string | number => {
                    return (didReturn / dueReturn) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'returnToWorkAndRetentionRatesOfPermanentWorkersBeing',
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_274,
                  fieldLabel: Principle3Label.P3_QUESTION_141
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_275,
                  fieldLabel: Principle3Label.P3_QUESTION_142
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_276,
                  fieldLabel: Principle3Label.P3_QUESTION_143
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_277,
                  fieldLabel: Principle3Label.P3_QUESTION_144
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_281,
                  fieldLabel: Principle3Label.P3_QUESTION_145,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_274,
                    Principle3Key.P3_QUESTION_275,
                    Principle3Key.P3_QUESTION_276,
                    Principle3Key.P3_QUESTION_277
                  ],
                  formula: ([
                    followingPeriodMale,
                    followingPeriodFemale,
                    priorPeriodMale,
                    priorPeriodFemale
                  ]: any[]): string | number => {
                    const totalFollowingPeriod =
                      followingPeriodMale + followingPeriodFemale;
                    const totalPriorPeriod =
                      priorPeriodMale + priorPeriodFemale;

                    return (totalFollowingPeriod / totalPriorPeriod) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_282,
                  fieldLabel: Principle3Label.P3_QUESTION_146,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_274,
                    Principle3Key.P3_QUESTION_276
                  ],
                  formula: ([followingPeriodMale, priorPeriodMale]: any[]):
                    | string
                    | number => {
                    return (followingPeriodMale / priorPeriodMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_283,
                  fieldLabel: Principle3Label.P3_QUESTION_147,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_275,
                    Principle3Key.P3_QUESTION_277
                  ],
                  formula: ([followingPeriodFemale, priorPeriodFemale]: any[]):
                    | string
                    | number => {
                    return (followingPeriodFemale / priorPeriodFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_52
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_115,
            fieldLabel: Principle3Label.P3_QUESTION_46,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_116,
            fieldLabel: Principle3Label.P3_QUESTION_47,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_113,
            fieldLabel: Principle3Label.P3_QUESTION_44,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_114,
            fieldLabel: Principle3Label.P3_QUESTION_45,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_53
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_44
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_405,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_406,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_117,
                  fieldLabel: Principle3Label.P3_QUESTION_49
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_118,
                  fieldLabel: Principle3Label.P3_QUESTION_50
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_421,
                  fieldLabel: Principle3Label.P3_QUESTION_184,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_405,
                    Principle3Key.P3_QUESTION_406
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_374,
                  fieldLabel: Principle3Label.P3_QUESTION_180,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_117,
                    Principle3Key.P3_QUESTION_118
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_370,
                  fieldLabel: Principle3Label.P3_QUESTION_178,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_405,
                    Principle3Key.P3_QUESTION_406,
                    Principle3Key.P3_QUESTION_117,
                    Principle3Key.P3_QUESTION_118
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleInMembership,
                    femaleInMembership
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const totalInMembership =
                      maleInMembership + femaleInMembership;

                    return (totalInMembership / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_123,
                  fieldLabel: Principle3Label.P3_QUESTION_53,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_405,
                    Principle3Key.P3_QUESTION_117
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_125,
                  fieldLabel: Principle3Label.P3_QUESTION_55,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_406,
                    Principle3Key.P3_QUESTION_118
                  ],
                  formula: ([totalFemale, femaleInMembership]: any[]):
                    | number
                    | string => {
                    return (femaleInMembership / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_407,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_408,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_119,
                  fieldLabel: Principle3Label.P3_QUESTION_49
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_120,
                  fieldLabel: Principle3Label.P3_QUESTION_50
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_422,
                  fieldLabel: Principle3Label.P3_QUESTION_185,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_407,
                    Principle3Key.P3_QUESTION_408
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_375,
                  fieldLabel: Principle3Label.P3_QUESTION_180,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_119,
                    Principle3Key.P3_QUESTION_120
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_371,
                  fieldLabel: Principle3Label.P3_QUESTION_179,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_407,
                    Principle3Key.P3_QUESTION_408,
                    Principle3Key.P3_QUESTION_119,
                    Principle3Key.P3_QUESTION_120
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleInMembership,
                    femaleInMembership
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const totalInMembership =
                      maleInMembership + femaleInMembership;

                    return (totalInMembership / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_124,
                  fieldLabel: Principle3Label.P3_QUESTION_54,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_407,
                    Principle3Key.P3_QUESTION_119
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_126,
                  fieldLabel: Principle3Label.P3_QUESTION_56,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_408,
                    Principle3Key.P3_QUESTION_120
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_46
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_409,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_410,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_127,
                  fieldLabel: Principle3Label.P3_QUESTION_57
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_128,
                  fieldLabel: Principle3Label.P3_QUESTION_58
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_423,
                  fieldLabel: Principle3Label.P3_QUESTION_186,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_409,
                    Principle3Key.P3_QUESTION_410
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_376,
                  fieldLabel: Principle3Label.P3_QUESTION_181,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_127,
                    Principle3Key.P3_QUESTION_128
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_372,
                  fieldLabel: Principle3Label.P3_QUESTION_178,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_409,
                    Principle3Key.P3_QUESTION_410,
                    Principle3Key.P3_QUESTION_127,
                    Principle3Key.P3_QUESTION_128
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleInMembership,
                    femaleInMembership
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const totalInMembership =
                      maleInMembership + femaleInMembership;

                    return (totalInMembership / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_133,
                  fieldLabel: Principle3Label.P3_QUESTION_53,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_409,
                    Principle3Key.P3_QUESTION_127
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_135,
                  fieldLabel: Principle3Label.P3_QUESTION_55,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_410,
                    Principle3Key.P3_QUESTION_128
                  ],
                  formula: ([totalFemale, femaleInMembership]: any[]):
                    | number
                    | string => {
                    return (femaleInMembership / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_411,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_412,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_129,
                  fieldLabel: Principle3Label.P3_QUESTION_57
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_130,
                  fieldLabel: Principle3Label.P3_QUESTION_58
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_424,
                  fieldLabel: Principle3Label.P3_QUESTION_187,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_411,
                    Principle3Key.P3_QUESTION_412
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_464,
                  fieldLabel: Principle3Label.P3_QUESTION_181,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_129,
                    Principle3Key.P3_QUESTION_130
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_373,
                  fieldLabel: Principle3Label.P3_QUESTION_179,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_411,
                    Principle3Key.P3_QUESTION_412,
                    Principle3Key.P3_QUESTION_129,
                    Principle3Key.P3_QUESTION_130
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleInMembership,
                    femaleInMembership
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const totalInMembership =
                      maleInMembership + femaleInMembership;

                    return (totalInMembership / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_134,
                  fieldLabel: Principle3Label.P3_QUESTION_54,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_411,
                    Principle3Key.P3_QUESTION_129
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_136,
                  fieldLabel: Principle3Label.P3_QUESTION_56,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_412,
                    Principle3Key.P3_QUESTION_130
                  ],
                  formula: ([totalMale, maleInMembership]: any[]):
                    | number
                    | string => {
                    return (maleInMembership / totalMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_54
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_425,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_426,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_137,
                  fieldLabel: Principle3Label.P3_QUESTION_60
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_138,
                  fieldLabel: Principle3Label.P3_QUESTION_61
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_139,
                  fieldLabel: Principle3Label.P3_QUESTION_62
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_140,
                  fieldLabel: Principle3Label.P3_QUESTION_63
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_427,
                  fieldLabel: Principle3Label.P3_QUESTION_184,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_425,
                    Principle3Key.P3_QUESTION_426
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_377,
                  fieldLabel: Principle3Label.P3_QUESTION_182,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_137,
                    Principle3Key.P3_QUESTION_138
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_145,
                  fieldLabel: Principle3Label.P3_QUESTION_64,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_425,
                    Principle3Key.P3_QUESTION_426,
                    Principle3Key.P3_QUESTION_137,
                    Principle3Key.P3_QUESTION_138
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleHandS,
                    femaleHandS
                  ]: any[]): number | string => {
                    return (
                      ((maleHandS + femaleHandS) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_149,
                  fieldLabel: Principle3Label.P3_QUESTION_66,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_425,
                    Principle3Key.P3_QUESTION_137
                  ],
                  formula: ([permanentMale, maleHandS]: any[]):
                    | number
                    | string => {
                    return (maleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_150,
                  fieldLabel: Principle3Label.P3_QUESTION_67,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_426,
                    Principle3Key.P3_QUESTION_138
                  ],
                  formula: ([permanentMale, femaleHandS]: any[]):
                    | number
                    | string => {
                    return (femaleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_378,
                  fieldLabel: Principle3Label.P3_QUESTION_183,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_139,
                    Principle3Key.P3_QUESTION_140
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_146,
                  fieldLabel: Principle3Label.P3_QUESTION_65,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_425,
                    Principle3Key.P3_QUESTION_426,
                    Principle3Key.P3_QUESTION_139,
                    Principle3Key.P3_QUESTION_140
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleSkill,
                    femaleSkill
                  ]: any[]): number | string => {
                    return (
                      ((maleSkill + femaleSkill) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_151,
                  fieldLabel: Principle3Label.P3_QUESTION_68,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_425,
                    Principle3Key.P3_QUESTION_139
                  ],
                  formula: ([permanentMale, maleSkill]: any[]):
                    | number
                    | string => {
                    return (maleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_152,
                  fieldLabel: Principle3Label.P3_QUESTION_69,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_426,
                    Principle3Key.P3_QUESTION_140
                  ],
                  formula: ([permanentMale, femaleSkill]: any[]):
                    | number
                    | string => {
                    return (femaleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_461,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_430,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_153,
                  fieldLabel: Principle3Label.P3_QUESTION_60
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_154,
                  fieldLabel: Principle3Label.P3_QUESTION_61
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_155,
                  fieldLabel: Principle3Label.P3_QUESTION_62
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_156,
                  fieldLabel: Principle3Label.P3_QUESTION_63
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_431,
                  fieldLabel: Principle3Label.P3_QUESTION_185,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_430
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_379,
                  fieldLabel: Principle3Label.P3_QUESTION_182,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_153,
                    Principle3Key.P3_QUESTION_154
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_157,
                  fieldLabel: Principle3Label.P3_QUESTION_64,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_430,
                    Principle3Key.P3_QUESTION_153,
                    Principle3Key.P3_QUESTION_154
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleHandS,
                    femaleHandS
                  ]: any[]): number | string => {
                    return (
                      ((maleHandS + femaleHandS) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_159,
                  fieldLabel: Principle3Label.P3_QUESTION_66,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_153
                  ],
                  formula: ([permanentMale, maleHandS]: any[]):
                    | number
                    | string => {
                    return (maleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_160,
                  fieldLabel: Principle3Label.P3_QUESTION_67,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_154
                  ],
                  formula: ([permanentMale, femaleHandS]: any[]):
                    | number
                    | string => {
                    return (femaleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_380,
                  fieldLabel: Principle3Label.P3_QUESTION_183,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_155,
                    Principle3Key.P3_QUESTION_156
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_158,
                  fieldLabel: Principle3Label.P3_QUESTION_65,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_430,
                    Principle3Key.P3_QUESTION_155,
                    Principle3Key.P3_QUESTION_156
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleSkill,
                    femaleSkill
                  ]: any[]): number | string => {
                    return (
                      ((maleSkill + femaleSkill) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_161,
                  fieldLabel: Principle3Label.P3_QUESTION_68,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_461,
                    Principle3Key.P3_QUESTION_155
                  ],
                  formula: ([permanentMale, maleSkill]: any[]):
                    | number
                    | string => {
                    return (maleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_162,
                  fieldLabel: Principle3Label.P3_QUESTION_69,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_430,
                    Principle3Key.P3_QUESTION_156
                  ],
                  formula: ([permanentMale, femaleSkill]: any[]):
                    | number
                    | string => {
                    return (femaleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_16
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_435,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_436,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_163,
                  fieldLabel: Principle3Label.P3_QUESTION_70
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_164,
                  fieldLabel: Principle3Label.P3_QUESTION_71
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_165,
                  fieldLabel: Principle3Label.P3_QUESTION_72
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_166,
                  fieldLabel: Principle3Label.P3_QUESTION_73
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_437,
                  fieldLabel: Principle3Label.P3_QUESTION_186,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_435,
                    Principle3Key.P3_QUESTION_436
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_381,
                  fieldLabel: Principle3Label.P3_QUESTION_182,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_163,
                    Principle3Key.P3_QUESTION_164
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_167,
                  fieldLabel: Principle3Label.P3_QUESTION_74,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_435,
                    Principle3Key.P3_QUESTION_436,
                    Principle3Key.P3_QUESTION_163,
                    Principle3Key.P3_QUESTION_164
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleHandS,
                    femaleHandS
                  ]: any[]): number | string => {
                    return (
                      ((maleHandS + femaleHandS) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_169,
                  fieldLabel: Principle3Label.P3_QUESTION_76,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_435,
                    Principle3Key.P3_QUESTION_163
                  ],
                  formula: ([permanentMale, maleHandS]: any[]):
                    | number
                    | string => {
                    return (maleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_170,
                  fieldLabel: Principle3Label.P3_QUESTION_77,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_436,
                    Principle3Key.P3_QUESTION_164
                  ],
                  formula: ([permanentMale, femaleHandS]: any[]):
                    | number
                    | string => {
                    return (femaleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                ,
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_382,
                  fieldLabel: Principle3Label.P3_QUESTION_183,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_165,
                    Principle3Key.P3_QUESTION_166
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_168,
                  fieldLabel: Principle3Label.P3_QUESTION_75,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_435,
                    Principle3Key.P3_QUESTION_436,
                    Principle3Key.P3_QUESTION_165,
                    Principle3Key.P3_QUESTION_166
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleSkill,
                    femaleSkill
                  ]: any[]): number | string => {
                    return (
                      ((maleSkill + femaleSkill) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_171,
                  fieldLabel: Principle3Label.P3_QUESTION_78,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_435,
                    Principle3Key.P3_QUESTION_165
                  ],
                  formula: ([permanentMale, maleSkill]: any[]):
                    | number
                    | string => {
                    return (maleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_172,
                  fieldLabel: Principle3Label.P3_QUESTION_79,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_436,
                    Principle3Key.P3_QUESTION_166
                  ],
                  formula: ([permanentMale, femaleSkill]: any[]):
                    | number
                    | string => {
                    return (femaleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_441,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_442,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_173,
                  fieldLabel: Principle3Label.P3_QUESTION_70
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_174,
                  fieldLabel: Principle3Label.P3_QUESTION_71
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_175,
                  fieldLabel: Principle3Label.P3_QUESTION_72
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_176,
                  fieldLabel: Principle3Label.P3_QUESTION_73
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_443,
                  fieldLabel: Principle3Label.P3_QUESTION_187,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_441,
                    Principle3Key.P3_QUESTION_442
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_383,
                  fieldLabel: Principle3Label.P3_QUESTION_182,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_173,
                    Principle3Key.P3_QUESTION_174
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_177,
                  fieldLabel: Principle3Label.P3_QUESTION_74,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_441,
                    Principle3Key.P3_QUESTION_442,
                    Principle3Key.P3_QUESTION_173,
                    Principle3Key.P3_QUESTION_174
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleHandS,
                    femaleHandS
                  ]: any[]): number | string => {
                    return (
                      ((maleHandS + femaleHandS) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_179,
                  fieldLabel: Principle3Label.P3_QUESTION_76,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_441,
                    Principle3Key.P3_QUESTION_173
                  ],
                  formula: ([permanentMale, maleHandS]: any[]):
                    | number
                    | string => {
                    return (maleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_180,
                  fieldLabel: Principle3Label.P3_QUESTION_77,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_442,
                    Principle3Key.P3_QUESTION_174
                  ],
                  formula: ([permanentMale, femaleHandS]: any[]):
                    | number
                    | string => {
                    return (femaleHandS / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_384,
                  fieldLabel: Principle3Label.P3_QUESTION_183,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_175,
                    Principle3Key.P3_QUESTION_176
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_178,
                  fieldLabel: Principle3Label.P3_QUESTION_75,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_441,
                    Principle3Key.P3_QUESTION_442,
                    Principle3Key.P3_QUESTION_175,
                    Principle3Key.P3_QUESTION_176
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    maleSkill,
                    femaleSkill
                  ]: any[]): number | string => {
                    return (
                      ((maleSkill + femaleSkill) /
                        (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_181,
                  fieldLabel: Principle3Label.P3_QUESTION_78,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_441,
                    Principle3Key.P3_QUESTION_175
                  ],
                  formula: ([permanentMale, maleSkill]: any[]):
                    | number
                    | string => {
                    return (maleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_182,
                  fieldLabel: Principle3Label.P3_QUESTION_79,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_442,
                    Principle3Key.P3_QUESTION_176
                  ],
                  formula: ([permanentMale, femaleSkill]: any[]):
                    | number
                    | string => {
                    return (femaleSkill / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_55
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_447,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_448,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_183,
                  fieldLabel: Principle3Label.P3_QUESTION_81
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_184,
                  fieldLabel: Principle3Label.P3_QUESTION_82
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_449,
                  fieldLabel: Principle3Label.P3_QUESTION_184,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_447,
                    Principle3Key.P3_QUESTION_448
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_385,
                  fieldLabel: Principle3Label.P3_QUESTION_188,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_183,
                    Principle3Key.P3_QUESTION_184
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_187,
                  fieldLabel: Principle3Label.P3_QUESTION_83,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_447,
                    Principle3Key.P3_QUESTION_448,
                    Principle3Key.P3_QUESTION_183,
                    Principle3Key.P3_QUESTION_184
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    male,
                    female
                  ]: any[]): number | string => {
                    return (
                      ((male + female) / (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_189,
                  fieldLabel: Principle3Label.P3_QUESTION_85,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_447,
                    Principle3Key.P3_QUESTION_183
                  ],
                  formula: ([permanentMale, male]: any[]): number | string => {
                    return (male / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_191,
                  fieldLabel: Principle3Label.P3_QUESTION_87,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_448,
                    Principle3Key.P3_QUESTION_184
                  ],
                  formula: ([permanentMale, female]: any[]):
                    | number
                    | string => {
                    return (female / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_450,
                  fieldLabel: Principle3Label.P3_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_451,
                  fieldLabel: Principle3Label.P3_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_185,
                  fieldLabel: Principle3Label.P3_QUESTION_81
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_186,
                  fieldLabel: Principle3Label.P3_QUESTION_82
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_462,
                  fieldLabel: Principle3Label.P3_QUESTION_185,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_450,
                    Principle3Key.P3_QUESTION_451
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_386,
                  fieldLabel: Principle3Label.P3_QUESTION_189,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_185,
                    Principle3Key.P3_QUESTION_186
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_188,
                  fieldLabel: Principle3Label.P3_QUESTION_84,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_450,
                    Principle3Key.P3_QUESTION_451,
                    Principle3Key.P3_QUESTION_185,
                    Principle3Key.P3_QUESTION_186
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    male,
                    female
                  ]: any[]): number | string => {
                    return (
                      ((male + female) / (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_190,
                  fieldLabel: Principle3Label.P3_QUESTION_86,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_450,
                    Principle3Key.P3_QUESTION_185
                  ],
                  formula: ([permanentMale, male]: any[]): number | string => {
                    return (male / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_192,
                  fieldLabel: Principle3Label.P3_QUESTION_88,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_451,
                    Principle3Key.P3_QUESTION_186
                  ],
                  formula: ([permanentMale, female]: any[]):
                    | number
                    | string => {
                    return (female / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_452,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_453,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_193,
                  fieldLabel: Principle3Label.P3_QUESTION_89
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_194,
                  fieldLabel: Principle3Label.P3_QUESTION_90
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_454,
                  fieldLabel: Principle3Label.P3_QUESTION_186,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_452,
                    Principle3Key.P3_QUESTION_453
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_387,
                  fieldLabel: Principle3Label.P3_QUESTION_190,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_193,
                    Principle3Key.P3_QUESTION_194
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_197,
                  fieldLabel: Principle3Label.P3_QUESTION_91,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_452,
                    Principle3Key.P3_QUESTION_453,
                    Principle3Key.P3_QUESTION_193,
                    Principle3Key.P3_QUESTION_194
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    male,
                    female
                  ]: any[]): number | string => {
                    return (
                      ((male + female) / (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_199,
                  fieldLabel: Principle3Label.P3_QUESTION_93,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_452,
                    Principle3Key.P3_QUESTION_193
                  ],
                  formula: ([permanentMale, male]: any[]): number | string => {
                    return (male / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_201,
                  fieldLabel: Principle3Label.P3_QUESTION_95,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_453,
                    Principle3Key.P3_QUESTION_194
                  ],
                  formula: ([permanentMale, female]: any[]):
                    | number
                    | string => {
                    return (female / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },

          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              name: 'detailsOfPerformanceAndCareerDevelopmentWorkers',
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_455,
                  fieldLabel: Principle3Label.P3_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_456,
                  fieldLabel: Principle3Label.P3_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_195,
                  fieldLabel: Principle3Label.P3_QUESTION_89
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_196,
                  fieldLabel: Principle3Label.P3_QUESTION_90
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_457,
                  fieldLabel: Principle3Label.P3_QUESTION_187,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_455,
                    Principle3Key.P3_QUESTION_456
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_388,
                  fieldLabel: Principle3Label.P3_QUESTION_191,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_195,
                    Principle3Key.P3_QUESTION_196
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_198,
                  fieldLabel: Principle3Label.P3_QUESTION_92,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_455,
                    Principle3Key.P3_QUESTION_456,
                    Principle3Key.P3_QUESTION_195,
                    Principle3Key.P3_QUESTION_196
                  ],
                  formula: ([
                    permanentMale,
                    permanentFemale,
                    male,
                    female
                  ]: any[]): number | string => {
                    return (
                      ((male + female) / (permanentMale + permanentFemale)) *
                      100
                    );
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_200,
                  fieldLabel: Principle3Label.P3_QUESTION_94,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_455,
                    Principle3Key.P3_QUESTION_195
                  ],
                  formula: ([permanentMale, male]: any[]): number | string => {
                    return (male / permanentMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_202,
                  fieldLabel: Principle3Label.P3_QUESTION_96,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_456,
                    Principle3Key.P3_QUESTION_196
                  ],
                  formula: ([permanentMale, female]: any[]):
                    | number
                    | string => {
                    return (female / permanentMale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_56
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_57
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_203,
            fieldLabel: Principle3Label.P3_QUESTION_99,
            options: ['Yes', 'No'],
            colSpan: true
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_58
          },

          {
            fieldType: inputType.ADDMORE_TEXTAREA,
            formList: {
              name: 'workRelatedHazardsAndAssessRisks',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle3Key.P3_QUESTION_204,
                  fieldLabel: Principle3Label.P3_QUESTION_101
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_59
          },

          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_205,
            fieldLabel: Principle3Label.P3_QUESTION_103,
            options: ['Yes', 'No'],
            colSpan: true
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_60
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_206,
            fieldLabel: Principle3Label.P3_QUESTION_105,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_61
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_107
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_108
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_207,
                  fieldLabel: Principle3Label.P3_QUESTION_109
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_208,
                  fieldLabel: Principle3Label.P3_QUESTION_110
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_209,
                  fieldLabel: Principle3Label.P3_QUESTION_109
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_210,
                  fieldLabel: Principle3Label.P3_QUESTION_110
                }
              ],
              formCalculations: [
                {
                  fieldType: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_310,
                  fieldLabel: Principle3Label.P3_QUESTION_174,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_207,
                    Principle3Key.P3_QUESTION_208
                  ],
                  formula: ([daysLost, totalHours]: any[]): string | number => {
                    return (daysLost * 1000000) / totalHours;
                  }
                },
                {
                  fieldType: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_311,
                  fieldLabel: Principle3Label.P3_QUESTION_175,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_209,
                    Principle3Key.P3_QUESTION_210
                  ],
                  formula: ([daysLost, totalHours]: any[]): string | number => {
                    return (daysLost * 1000000) / totalHours;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_211,
                  fieldLabel: Principle3Label.P3_QUESTION_109
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_212,
                  fieldLabel: Principle3Label.P3_QUESTION_110
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_213,
                  fieldLabel: Principle3Label.P3_QUESTION_109
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_214,
                  fieldLabel: Principle3Label.P3_QUESTION_110
                }
              ],
              formCalculations: [
                {
                  fieldType: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_312,
                  fieldLabel: Principle3Label.P3_QUESTION_176,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_211,
                    Principle3Key.P3_QUESTION_212
                  ],
                  formula: ([daysLost, totalHours]: any[]): string | number => {
                    return (daysLost * 1000000) / totalHours;
                  }
                },
                {
                  fieldType: inputType.DISPLAY,
                  fieldName: Principle3Key.P3_QUESTION_313,
                  fieldLabel: Principle3Label.P3_QUESTION_177,
                  relatedKey: [
                    Principle3Key.P3_QUESTION_213,
                    Principle3Key.P3_QUESTION_214
                  ],
                  formula: ([daysLost, totalHours]: any[]): string | number => {
                    return (daysLost * 1000000) / totalHours;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_111
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_215,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_216,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_217,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_218,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_112
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_219,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_220,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_221,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_222,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_113
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_223,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_224,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_225,
            fieldLabel: Principle3Label.P3_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_226,
            fieldLabel: Principle3Label.P3_QUESTION_26
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_62
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_227,
            askAIkey: 'P3E_SAFE_WORKPLACE',
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_63
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_2,
                  heading: Principle3Label.P3_QUESTION_116
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_228,
                  fieldLabel: Principle3Label.P3_QUESTION_117
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_229,
                  fieldLabel: Principle3Label.P3_QUESTION_118
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle3Key.P3_QUESTION_230,
                  fieldLabel: Principle3Label.P3_QUESTION_119
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_231,
                  fieldLabel: Principle3Label.P3_QUESTION_117
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_232,
                  fieldLabel: Principle3Label.P3_QUESTION_118
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle3Key.P3_QUESTION_233,
                  fieldLabel: Principle3Label.P3_QUESTION_119
                },
                {
                  type: inputType.HEADING_2,
                  heading: Principle3Label.P3_QUESTION_120
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_16
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_234,
                  fieldLabel: Principle3Label.P3_QUESTION_117
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_235,
                  fieldLabel: Principle3Label.P3_QUESTION_118
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle3Key.P3_QUESTION_236,
                  fieldLabel: Principle3Label.P3_QUESTION_119
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle3Label.P3_HEADING_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_237,
                  fieldLabel: Principle3Label.P3_QUESTION_117
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle3Key.P3_QUESTION_238,
                  fieldLabel: Principle3Label.P3_QUESTION_118
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle3Key.P3_QUESTION_239,
                  fieldLabel: Principle3Label.P3_QUESTION_119
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_64
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_122
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_240,
            fieldLabel: Principle3Label.P3_QUESTION_123,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_241,
            fieldLabel: Principle3Label.P3_QUESTION_124,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_65
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_242,
            fieldLabel: Principle3Label.P3_QUESTION_126,
            askAIkey: 'P3E_SAFETY_ACTIONS'
          }
        ]
      }
    ]
  },

  {
    key: '2',
    label: Principle3Label.P3_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_66
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_243,
            fieldLabel: Principle3Label.P3_QUESTION_33,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_244,
            fieldLabel: Principle3Label.P3_QUESTION_133,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_67
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_245,
            fieldLabel: Principle3Label.P3_QUESTION_126,
            askAIkey: 'P3L_VC_STATUTORY_DUES'
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_68
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_33
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_69
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_246,
            fieldLabel: Principle3Label.P3_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_247,
            fieldLabel: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_70
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_248,
            fieldLabel: Principle3Label.P3_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_249,
            fieldLabel: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_QUESTION_133
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_71
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_250,
            fieldLabel: Principle3Label.P3_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_251,
            fieldLabel: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_72
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_252,
            fieldLabel: Principle3Label.P3_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle3Key.P3_QUESTION_253,
            fieldLabel: Principle3Label.P3_HEADING_17
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_73
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_254,
            fieldLabel: Principle3Label.P3_QUESTION_127,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_74
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_44
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_255,
            fieldLabel: Principle3Label.P3_QUESTION_123,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle3Key.P3_QUESTION_256,
            fieldLabel: Principle3Label.P3_QUESTION_124,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle3Label.P3_HEADING_75
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle3Key.P3_QUESTION_257,
            askAIkey: 'P3L_VC_SAFETY_ACTIONS'
          }
        ]
      }
    ]
  }
];

export const principle4TabQuestions = [
  {
    key: '1',
    label: Principle4Label.P4_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle4Label.P4_QUESTION_1
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle4Key.P4_QUESTION_1,
            askAIkey: 'P4E_STAKEHOLDER_ID'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle4Label.P4_QUESTION_2
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle4Key.P4_QUESTION_31,
            formList: {
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle4Key.P4_QUESTION_2,
                  fieldLabel: Principle4Label.P4_HEADING_4,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName: Principle4Key.P4_QUESTION_3,
                  fieldLabel: Principle4Label.P4_HEADING_5,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle4Key.P4_QUESTION_4,
                  fieldLabel: Principle4Label.P4_HEADING_6,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle4Key.P4_QUESTION_5,
                  fieldLabel: Principle4Label.P4_HEADING_7,
                  options: ['Annually', 'Half yearly', 'Quarterly', 'Other'],
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle4Key.P4_QUESTION_6,
                  fieldLabel: Principle4Label.P4_HEADING_8,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle4Label.P4_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle4Label.P4_QUESTION_3
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle4Key.P4_QUESTION_7,
            askAIkey: 'P4L_BOARD_CONSULTATION'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle4Label.P4_QUESTION_4
          },

          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle4Key.P4_QUESTION_8,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P4L_STAKEHOLDER_INPUTS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle4Label.P4_QUESTION_5
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle4Key.P4_QUESTION_9,
            askAIkey: 'P4L_VULNERABLE_ENGAGEMENT'
          }
        ]
      }
    ]
  }
];

export const principle5TabQuestions = [
  {
    key: '1',
    label: Principle5Label.P5_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_1
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_13
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_1,
                  fieldLabel: Principle5Label.P5_LABEL_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_2,
                  fieldLabel: Principle5Label.P5_LABEL_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_3,
                  fieldLabel: Principle5Label.P5_LABEL_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_4,
                  fieldLabel: Principle5Label.P5_LABEL_4
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_283,
                  fieldLabel: Principle5Label.P5_LABEL_71,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_1,
                    Principle5Key.P5_QUESTION_2
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_253,
                  fieldLabel: Principle5Label.P5_LABEL_5,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_3,
                    Principle5Key.P5_QUESTION_4
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_9,
                  fieldLabel: Principle5Label.P5_LABEL_45,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_1,
                    Principle5Key.P5_QUESTION_2,
                    Principle5Key.P5_QUESTION_3,
                    Principle5Key.P5_QUESTION_4
                  ],
                  formula: ([
                    totalParmanent,
                    totalOther,
                    coveredParmanent,
                    coveredOther
                  ]: any[]): number | string => {
                    const total = totalParmanent + totalOther;
                    const covered = coveredParmanent + coveredOther;

                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_10,
                  fieldLabel: Principle5Label.P5_LABEL_46,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_1,
                    Principle5Key.P5_QUESTION_3
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_11,
                  fieldLabel: Principle5Label.P5_LABEL_47,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_2,
                    Principle5Key.P5_QUESTION_4
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_5,
                  fieldLabel: Principle5Label.P5_LABEL_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_6,
                  fieldLabel: Principle5Label.P5_LABEL_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_7,
                  fieldLabel: Principle5Label.P5_LABEL_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_8,
                  fieldLabel: Principle5Label.P5_LABEL_4
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_284,
                  fieldLabel: Principle5Label.P5_LABEL_71,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_5,
                    Principle5Key.P5_QUESTION_6
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_254,
                  fieldLabel: Principle5Label.P5_LABEL_5,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_7,
                    Principle5Key.P5_QUESTION_8
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_12,
                  fieldLabel: Principle5Label.P5_LABEL_45,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_5,
                    Principle5Key.P5_QUESTION_6,
                    Principle5Key.P5_QUESTION_7,
                    Principle5Key.P5_QUESTION_8
                  ],
                  formula: ([
                    totalParmanent,
                    totalOther,
                    coveredParmanent,
                    coveredOther
                  ]: any[]): number | string => {
                    const total = totalParmanent + totalOther;
                    const covered = coveredParmanent + coveredOther;

                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_13,
                  fieldLabel: Principle5Label.P5_LABEL_46,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_5,
                    Principle5Key.P5_QUESTION_7
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_14,
                  fieldLabel: Principle5Label.P5_LABEL_47,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_6,
                    Principle5Key.P5_QUESTION_8
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_14
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_15,
                  fieldLabel: Principle5Label.P5_LABEL_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_16,
                  fieldLabel: Principle5Label.P5_LABEL_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_17,
                  fieldLabel: Principle5Label.P5_LABEL_10
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_18,
                  fieldLabel: Principle5Label.P5_LABEL_11
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_285,
                  fieldLabel: Principle5Label.P5_LABEL_72,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_15,
                    Principle5Key.P5_QUESTION_16
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_255,
                  fieldLabel: Principle5Label.P5_LABEL_12,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_17,
                    Principle5Key.P5_QUESTION_18
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_19,
                  fieldLabel: Principle5Label.P5_LABEL_48,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_15,
                    Principle5Key.P5_QUESTION_16,
                    Principle5Key.P5_QUESTION_17,
                    Principle5Key.P5_QUESTION_18
                  ],
                  formula: ([
                    totalParmanent,
                    totalOther,
                    coveredParmanent,
                    coveredOther
                  ]: any[]): number | string => {
                    const total = totalParmanent + totalOther;
                    const covered = coveredParmanent + coveredOther;

                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_20,
                  fieldLabel: Principle5Label.P5_LABEL_49,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_15,
                    Principle5Key.P5_QUESTION_17
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_50,
                  fieldLabel: Principle5Label.P5_LABEL_50,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_16,
                    Principle5Key.P5_QUESTION_18
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_22,
                  fieldLabel: Principle5Label.P5_LABEL_8
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_23,
                  fieldLabel: Principle5Label.P5_LABEL_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_24,
                  fieldLabel: Principle5Label.P5_LABEL_10
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_25,
                  fieldLabel: Principle5Label.P5_LABEL_11
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_286,
                  fieldLabel: Principle5Label.P5_LABEL_72,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_22,
                    Principle5Key.P5_QUESTION_23
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_256,
                  fieldLabel: Principle5Label.P5_LABEL_12,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_24,
                    Principle5Key.P5_QUESTION_25
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_26,
                  fieldLabel: Principle5Label.P5_LABEL_48,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_22,
                    Principle5Key.P5_QUESTION_23,
                    Principle5Key.P5_QUESTION_24,
                    Principle5Key.P5_QUESTION_25
                  ],
                  formula: ([
                    totalParmanent,
                    totalOther,
                    coveredParmanent,
                    coveredOther
                  ]: any[]): number | string => {
                    const total = totalParmanent + totalOther;
                    const covered = coveredParmanent + coveredOther;

                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_27,
                  fieldLabel: Principle5Label.P5_LABEL_49,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_22,
                    Principle5Key.P5_QUESTION_24
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_28,
                  fieldLabel: Principle5Label.P5_LABEL_50,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_23,
                    Principle5Key.P5_QUESTION_25
                  ],
                  formula: ([total, covered]: any[]): number | string => {
                    return (covered / total) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_2
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_13
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_6
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_37,
                  fieldLabel: Principle5Label.P5_LABEL_111
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_38,
                  fieldLabel: Principle5Label.P5_LABEL_112
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_39,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_40,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_41,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_42,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_259,
                  fieldLabel: Principle5Label.P5_LABEL_55,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_37,
                    Principle5Key.P5_QUESTION_38
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_257,
                  fieldLabel: Principle5Label.P5_LABEL_51,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_39,
                    Principle5Key.P5_QUESTION_40
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_250,
                  fieldLabel: Principle5Label.P5_LABEL_52,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_37,
                    Principle5Key.P5_QUESTION_38,
                    Principle5Key.P5_QUESTION_39,
                    Principle5Key.P5_QUESTION_40
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_258,
                  fieldLabel: Principle5Label.P5_LABEL_53,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_41,
                    Principle5Key.P5_QUESTION_42
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_251,
                  fieldLabel: Principle5Label.P5_LABEL_54,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_37,
                    Principle5Key.P5_QUESTION_38,
                    Principle5Key.P5_QUESTION_41,
                    Principle5Key.P5_QUESTION_42
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_246,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_37,
                    Principle5Key.P5_QUESTION_39
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_247,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_38,
                    Principle5Key.P5_QUESTION_40
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_248,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_37,
                    Principle5Key.P5_QUESTION_41
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_249,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_38,
                    Principle5Key.P5_QUESTION_42
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_43,
                  fieldLabel: Principle5Label.P5_LABEL_111
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_44,
                  fieldLabel: Principle5Label.P5_LABEL_112
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_45,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_46,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_47,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_48,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_260,
                  fieldLabel: Principle5Label.P5_LABEL_55,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_43,
                    Principle5Key.P5_QUESTION_44
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_261,
                  fieldLabel: Principle5Label.P5_LABEL_51,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_45,
                    Principle5Key.P5_QUESTION_46
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_49,
                  fieldLabel: Principle5Label.P5_LABEL_52,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_43,
                    Principle5Key.P5_QUESTION_44,
                    Principle5Key.P5_QUESTION_45,
                    Principle5Key.P5_QUESTION_46
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_262,
                  fieldLabel: Principle5Label.P5_LABEL_53,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_47,
                    Principle5Key.P5_QUESTION_48
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_289,
                  fieldLabel: Principle5Label.P5_LABEL_54,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_43,
                    Principle5Key.P5_QUESTION_44,
                    Principle5Key.P5_QUESTION_47,
                    Principle5Key.P5_QUESTION_48
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_51,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_43,
                    Principle5Key.P5_QUESTION_45
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_52,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_44,
                    Principle5Key.P5_QUESTION_46
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_53,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_43,
                    Principle5Key.P5_QUESTION_47
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_54,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_44,
                    Principle5Key.P5_QUESTION_48
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_7
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_55,
                  fieldLabel: Principle5Label.P5_LABEL_111
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_56,
                  fieldLabel: Principle5Label.P5_LABEL_112
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_57,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_58,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_59,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_60,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_263,
                  fieldLabel: Principle5Label.P5_LABEL_56,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_55,
                    Principle5Key.P5_QUESTION_56
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_264,
                  fieldLabel: Principle5Label.P5_LABEL_63,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_57,
                    Principle5Key.P5_QUESTION_58
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_61,
                  fieldLabel: Principle5Label.P5_LABEL_64,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_55,
                    Principle5Key.P5_QUESTION_56,
                    Principle5Key.P5_QUESTION_57,
                    Principle5Key.P5_QUESTION_58
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_265,
                  fieldLabel: Principle5Label.P5_LABEL_65,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_59,
                    Principle5Key.P5_QUESTION_60
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_62,
                  fieldLabel: Principle5Label.P5_LABEL_66,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_55,
                    Principle5Key.P5_QUESTION_56,
                    Principle5Key.P5_QUESTION_59,
                    Principle5Key.P5_QUESTION_60
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_63,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_55,
                    Principle5Key.P5_QUESTION_57
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_64,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_56,
                    Principle5Key.P5_QUESTION_58
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_65,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_55,
                    Principle5Key.P5_QUESTION_59
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_66,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_56,
                    Principle5Key.P5_QUESTION_60
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_67,
                  fieldLabel: Principle5Label.P5_LABEL_111
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_68,
                  fieldLabel: Principle5Label.P5_LABEL_112
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_69,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_70,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_71,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_72,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_266,
                  fieldLabel: Principle5Label.P5_LABEL_56,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_67,
                    Principle5Key.P5_QUESTION_68
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_267,
                  fieldLabel: Principle5Label.P5_LABEL_63,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_69,
                    Principle5Key.P5_QUESTION_70
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_281,
                  fieldLabel: Principle5Label.P5_LABEL_64,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_67,
                    Principle5Key.P5_QUESTION_68,
                    Principle5Key.P5_QUESTION_69,
                    Principle5Key.P5_QUESTION_70
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_268,
                  fieldLabel: Principle5Label.P5_LABEL_65,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_71,
                    Principle5Key.P5_QUESTION_72
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_282,
                  fieldLabel: Principle5Label.P5_LABEL_66,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_67,
                    Principle5Key.P5_QUESTION_68,
                    Principle5Key.P5_QUESTION_71,
                    Principle5Key.P5_QUESTION_72
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_121,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_67,
                    Principle5Key.P5_QUESTION_69
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_122,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_68,
                    Principle5Key.P5_QUESTION_70
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_123,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_67,
                    Principle5Key.P5_QUESTION_71
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_124,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_68,
                    Principle5Key.P5_QUESTION_72
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_14
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_11
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_287,
                  fieldLabel: Principle5Label.P5_LABEL_115
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_74,
                  fieldLabel: Principle5Label.P5_LABEL_116
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_75,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_76,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_252,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_78,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_269,
                  fieldLabel: Principle5Label.P5_LABEL_57,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_287,
                    Principle5Key.P5_QUESTION_74
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_270,
                  fieldLabel: Principle5Label.P5_LABEL_59,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_75,
                    Principle5Key.P5_QUESTION_76
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_97,
                  fieldLabel: Principle5Label.P5_LABEL_117,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_287,
                    Principle5Key.P5_QUESTION_74,
                    Principle5Key.P5_QUESTION_75,
                    Principle5Key.P5_QUESTION_76
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_271,
                  fieldLabel: Principle5Label.P5_LABEL_61,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_252,
                    Principle5Key.P5_QUESTION_78
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_98,
                  fieldLabel: Principle5Label.P5_LABEL_62,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_287,
                    Principle5Key.P5_QUESTION_74,
                    Principle5Key.P5_QUESTION_252,
                    Principle5Key.P5_QUESTION_78
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_99,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_287,
                    Principle5Key.P5_QUESTION_75
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_100,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_74,
                    Principle5Key.P5_QUESTION_76
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_101,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_287,
                    Principle5Key.P5_QUESTION_252
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_102,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_74,
                    Principle5Key.P5_QUESTION_78
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_79,
                  fieldLabel: Principle5Label.P5_LABEL_115
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_80,
                  fieldLabel: Principle5Label.P5_LABEL_116
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_81,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_82,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_83,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_84,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_272,
                  fieldLabel: Principle5Label.P5_LABEL_57,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_79,
                    Principle5Key.P5_QUESTION_80
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_273,
                  fieldLabel: Principle5Label.P5_LABEL_59,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_81,
                    Principle5Key.P5_QUESTION_82
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_103,
                  fieldLabel: Principle5Label.P5_LABEL_117,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_79,
                    Principle5Key.P5_QUESTION_80,
                    Principle5Key.P5_QUESTION_81,
                    Principle5Key.P5_QUESTION_82
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_274,
                  fieldLabel: Principle5Label.P5_LABEL_61,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_83,
                    Principle5Key.P5_QUESTION_84
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_104,
                  fieldLabel: Principle5Label.P5_LABEL_62,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_79,
                    Principle5Key.P5_QUESTION_80,
                    Principle5Key.P5_QUESTION_83,
                    Principle5Key.P5_QUESTION_84
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_105,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_79,
                    Principle5Key.P5_QUESTION_81
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_106,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_80,
                    Principle5Key.P5_QUESTION_82
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_107,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_79,
                    Principle5Key.P5_QUESTION_83
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_108,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_80,
                    Principle5Key.P5_QUESTION_84
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_12
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_85,
                  fieldLabel: Principle5Label.P5_LABEL_115
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_86,
                  fieldLabel: Principle5Label.P5_LABEL_116
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_87,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_88,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_89,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_90,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_275,
                  fieldLabel: Principle5Label.P5_LABEL_58,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_85,
                    Principle5Key.P5_QUESTION_86
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_276,
                  fieldLabel: Principle5Label.P5_LABEL_67,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_87,
                    Principle5Key.P5_QUESTION_88
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_109,
                  fieldLabel: Principle5Label.P5_LABEL_68,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_85,
                    Principle5Key.P5_QUESTION_86,
                    Principle5Key.P5_QUESTION_87,
                    Principle5Key.P5_QUESTION_88
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_277,
                  fieldLabel: Principle5Label.P5_LABEL_69,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_89,
                    Principle5Key.P5_QUESTION_90
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_110,
                  fieldLabel: Principle5Label.P5_LABEL_70,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_85,
                    Principle5Key.P5_QUESTION_86,
                    Principle5Key.P5_QUESTION_89,
                    Principle5Key.P5_QUESTION_90
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_111,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_85,
                    Principle5Key.P5_QUESTION_87
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_112,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_86,
                    Principle5Key.P5_QUESTION_88
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_113,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_85,
                    Principle5Key.P5_QUESTION_89
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_114,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_86,
                    Principle5Key.P5_QUESTION_90
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_91,
                  fieldLabel: Principle5Label.P5_LABEL_115
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_92,
                  fieldLabel: Principle5Label.P5_LABEL_116
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_93,
                  fieldLabel: Principle5Label.P5_LABEL_102
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_94,
                  fieldLabel: Principle5Label.P5_LABEL_107
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_95,
                  fieldLabel: Principle5Label.P5_LABEL_104
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_96,
                  fieldLabel: Principle5Label.P5_LABEL_109
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_278,
                  fieldLabel: Principle5Label.P5_LABEL_58,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_91,
                    Principle5Key.P5_QUESTION_92
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_279,
                  fieldLabel: Principle5Label.P5_LABEL_67,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_93,
                    Principle5Key.P5_QUESTION_94
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_115,
                  fieldLabel: Principle5Label.P5_LABEL_68,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_91,
                    Principle5Key.P5_QUESTION_92,
                    Principle5Key.P5_QUESTION_93,
                    Principle5Key.P5_QUESTION_94
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_288,
                  fieldLabel: Principle5Label.P5_LABEL_69,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_95,
                    Principle5Key.P5_QUESTION_96
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_116,
                  fieldLabel: Principle5Label.P5_LABEL_70,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_91,
                    Principle5Key.P5_QUESTION_92,
                    Principle5Key.P5_QUESTION_95,
                    Principle5Key.P5_QUESTION_96
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    maleEqual,
                    femaleEqual
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const equalTo = maleEqual + femaleEqual;

                    return (equalTo / total) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_117,
                  fieldLabel: Principle5Label.P5_LABEL_103,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_91,
                    Principle5Key.P5_QUESTION_93
                  ],
                  formula: ([totalMale, maleEqual]: any[]): number | string => {
                    return (maleEqual / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_118,
                  fieldLabel: Principle5Label.P5_LABEL_105,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_92,
                    Principle5Key.P5_QUESTION_94
                  ],
                  formula: ([totalFemale, femaleEqual]: any[]):
                    | number
                    | string => {
                    return (femaleEqual / totalFemale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_119,
                  fieldLabel: Principle5Label.P5_LABEL_108,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_91,
                    Principle5Key.P5_QUESTION_95
                  ],
                  formula: ([totalMale, maleMore]: any[]): number | string => {
                    return (maleMore / totalMale) * 100;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle5Key.P5_QUESTION_120,
                  fieldLabel: Principle5Label.P5_LABEL_110,
                  relatedKey: [
                    Principle5Key.P5_QUESTION_92,
                    Principle5Key.P5_QUESTION_96
                  ],
                  formula: ([totalFemale, femaleMore]: any[]):
                    | number
                    | string => {
                    return (femaleMore / totalFemale) * 100;
                  },
                  units: Units.percentage
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_3
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_15
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_17
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_157,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_158,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_159,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_160,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_18
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_161,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_162,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_163,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_164,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_19
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_165,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_166,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_167,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_168,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_20
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_169,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_170,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_171,
            fieldLabel: Principle5Label.P5_LABEL_39
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle5Key.P5_QUESTION_172,
            fieldLabel: Principle5Label.P5_LABEL_40
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_16
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle5Label.P5_HEADING_21
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_173,
            fieldLabel: Principle5Label.P5_HEADING_4,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_174,
            fieldLabel: Principle5Label.P5_HEADING_5,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_4
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_175,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P5E_HR_FOCAL_POINT'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_5
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_176,
            askAIkey: 'P5E_HR_GRIEVANCES'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_6
          },

          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_22
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_177,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_178,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_179,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_180,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_181,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_182,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_23
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_183,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_184,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_185,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_186,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_187,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_188,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_24
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_195,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_196,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_197,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_198,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_199,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_200,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_25
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_201,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_202,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_203,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_204,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_205,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_206,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_26
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_207,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_208,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_209,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_210,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_211,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_212,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle5Label.P5_HEADING_27
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_213,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_214,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_215,
                  fieldLabel: Principle5Label.P5_LABEL_43
                },
                {
                  type: inputType.HEADING,
                  heading: Principle5Label.P5_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_216,
                  fieldLabel: Principle5Label.P5_LABEL_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle5Key.P5_QUESTION_217,
                  fieldLabel: Principle5Label.P5_LABEL_42
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle5Key.P5_QUESTION_218,
                  fieldLabel: Principle5Label.P5_LABEL_43
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_7
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_28
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_219,
            fieldLabel: Principle5Label.P5_HEADING_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_220,
            fieldLabel: Principle5Label.P5_HEADING_5
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_29
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_221,
            fieldLabel: Principle5Label.P5_HEADING_4,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_222,
            fieldLabel: Principle5Label.P5_HEADING_5,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_30
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_223,
            fieldLabel: Principle5Label.P5_HEADING_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle5Key.P5_QUESTION_224,
            fieldLabel: Principle5Label.P5_HEADING_5
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_8
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_225,
            askAIkey: 'P5E_ANTI_RETALIATION'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_9
          },

          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_226,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P5E_HR_CONTRACTS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_10
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_33
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_244,
            fieldLabel: Principle5Label.P5_LABEL_44
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_229,
            fieldLabel: Principle5Label.P5_HEADING_35,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_230,
            fieldLabel: Principle5Label.P5_HEADING_36,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_227,
            fieldLabel: Principle5Label.P5_HEADING_37,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_228,
            fieldLabel: Principle5Label.P5_HEADING_38,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_231,
            fieldLabel: Principle5Label.P5_HEADING_39,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_232,
            fieldLabel: Principle5Label.P5_HEADING_40,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_233,
            askAIkey: 'P5E_HR_CORRECTIVE_ACTIONS'
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle5Label.P5_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_12
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_234,
            askAIkey: 'P5L_HR_PROCESS_CHANGE'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_13
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_235,
            askAIkey: 'P5L_HR_DUE_DILIGENCE'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_14
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_236,
            askAIkey: 'P5L_VISITOR_ACCESSIBILITY'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_15
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_HEADING_34
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_245,
            fieldLabel: Principle5Label.P5_LABEL_44
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_237,
            fieldLabel: Principle5Label.P5_HEADING_22,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_238,
            fieldLabel: Principle5Label.P5_HEADING_23,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_239,
            fieldLabel: Principle5Label.P5_HEADING_24,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_240,
            fieldLabel: Principle5Label.P5_HEADING_25,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_241,
            fieldLabel: Principle5Label.P5_HEADING_26,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle5Key.P5_QUESTION_242,
            fieldLabel: Principle5Label.P5_HEADING_40,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle5Label.P5_QUESTION_16
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_243,
            askAIkey: 'P5L_HR_RISK_ACTIONS'
          }
        ]
      }
    ]
  }
];

export const principle6TabQuestions = [
  {
    key: '1',
    label: Principle6Label.P6_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_1
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_7
                },
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_1_1,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {label: 'GJ', value: 'GJ'},
                //     {label: 'kWh', value: 'kWh'}
                //   ]
                // },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_1,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_2,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_8
                },
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_3_1,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {label: 'GJ', value: 'GJ'},
                //     {label: 'kWh', value: 'kWh'}
                //   ]
                // },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_3,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_4,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_9
                },
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_5_1,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {label: 'GJ', value: 'GJ'},
                //     {label: 'kWh', value: 'kWh'}
                //   ]
                // },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_5,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_6,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_11
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_12
                },
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_9_1,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {label: 'GJ', value: 'GJ'},
                //     {label: 'kWh', value: 'kWh'}
                //   ]
                // },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_9,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_10,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_13
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_11,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_12,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_14
                },
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_13_1,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {label: 'GJ', value: 'GJ'},
                //     {label: 'kWh', value: 'kWh'}
                //   ]
                // },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_13,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_14,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.Gigajoules
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_17,
                  fieldLabel: Principle6Label.P6_LABEL_22,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_1,
                    Principle6Key.P6_QUESTION_3,
                    Principle6Key.P6_QUESTION_5,
                    Principle6Key.P6_QUESTION_9,
                    Principle6Key.P6_QUESTION_11,
                    Principle6Key.P6_QUESTION_13
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_18,
                  fieldLabel: Principle6Label.P6_LABEL_23,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_2,
                    Principle6Key.P6_QUESTION_4,
                    Principle6Key.P6_QUESTION_6,
                    Principle6Key.P6_QUESTION_10,
                    Principle6Key.P6_QUESTION_12,
                    Principle6Key.P6_QUESTION_14
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_7,
                  fieldLabel: Principle6Label.P6_LABEL_24,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_1,
                    Principle6Key.P6_QUESTION_3,
                    Principle6Key.P6_QUESTION_5
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_8,
                  fieldLabel: Principle6Label.P6_LABEL_25,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_2,
                    Principle6Key.P6_QUESTION_4,
                    Principle6Key.P6_QUESTION_6
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_15,
                  fieldLabel: Principle6Label.P6_LABEL_26,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_9,
                    Principle6Key.P6_QUESTION_11,
                    Principle6Key.P6_QUESTION_13
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_16,
                  fieldLabel: Principle6Label.P6_LABEL_27,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_10,
                    Principle6Key.P6_QUESTION_12,
                    Principle6Key.P6_QUESTION_14
                  ],
                  formula: calculateSum
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_17
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_19,
                  fieldLabel: Principle6Label.P6_LABEL_4,
                  placeHolder: '(A+B+C+D+E+F)',
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_20,
                  fieldLabel: Principle6Label.P6_LABEL_5
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_361,
                  fieldLabel: Principle6Label.P6_LABEL_30,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_19,
                    Principle6Key.P6_QUESTION_20
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_19_1,
                  fieldLabel: Principle6Label.P6_LABEL_4,
                  placeHolder: '(A+B+C+D+E+F)',
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_20_1,
                  fieldLabel: Principle6Label.P6_LABEL_5
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_362,
                  fieldLabel: Principle6Label.P6_LABEL_31,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_19_1,
                    Principle6Key.P6_QUESTION_20_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_111
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_19_2,
                  fieldLabel: Principle6Label.P6_LABEL_15,
                  placeHolder: '(A+B+C+D+E+F)',
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_20_2,
                  fieldLabel: Principle6Label.P6_LABEL_16
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_363,
                  fieldLabel: Principle6Label.P6_LABEL_28,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_19_2,
                    Principle6Key.P6_QUESTION_20_2
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_19_3,
                  fieldLabel: Principle6Label.P6_LABEL_15,
                  placeHolder: '(A+B+C+D+E+F)',
                  units: Units.Gigajoules
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_20_3,
                  fieldLabel: Principle6Label.P6_LABEL_16
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_364,
                  fieldLabel: Principle6Label.P6_LABEL_29,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_19_3,
                    Principle6Key.P6_QUESTION_20_3
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_21,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_22,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_23,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_24,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_20
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_25,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_2
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_365,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P6E_PAT_SCHEME'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_3
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_21
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_27,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_28,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_23
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_29,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_30,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_31,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_32,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_25
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_33,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_34,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_26
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_35,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_36,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_37,
                  fieldLabel: Principle6Label.P6_LABEL_32,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_27,
                    Principle6Key.P6_QUESTION_29,
                    Principle6Key.P6_QUESTION_31,
                    Principle6Key.P6_QUESTION_33,
                    Principle6Key.P6_QUESTION_35
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_38,
                  fieldLabel: Principle6Label.P6_LABEL_33,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_28,
                    Principle6Key.P6_QUESTION_30,
                    Principle6Key.P6_QUESTION_32,
                    Principle6Key.P6_QUESTION_34,
                    Principle6Key.P6_QUESTION_36
                  ],
                  formula: calculateSum
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_28
          },

          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_39,
            fieldLabel: Principle6Label.P6_LABEL_1,
            units: Units.kiloLitres
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_40,
            fieldLabel: Principle6Label.P6_LABEL_2,
            units: Units.kiloLitres
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_29
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_41,
                  fieldLabel: Principle6Label.P6_LABEL_17,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_42,
                  fieldLabel: Principle6Label.P6_LABEL_18
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_366,
                  fieldLabel: Principle6Label.P6_LABEL_34,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_41,
                    Principle6Key.P6_QUESTION_42
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_41_1,
                  fieldLabel: Principle6Label.P6_LABEL_17,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_42_1,
                  fieldLabel: Principle6Label.P6_LABEL_18
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_367,
                  fieldLabel: Principle6Label.P6_LABEL_35,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_41_1,
                    Principle6Key.P6_QUESTION_42_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_30
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_43,
                  fieldLabel: Principle6Label.P6_LABEL_19,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_44,
                  fieldLabel: Principle6Label.P6_LABEL_20
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_368,
                  fieldLabel: Principle6Label.P6_LABEL_36,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_43,
                    Principle6Key.P6_QUESTION_44
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_43_1,
                  fieldLabel: Principle6Label.P6_LABEL_19,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_44_1,
                  fieldLabel: Principle6Label.P6_LABEL_20
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_369,
                  fieldLabel: Principle6Label.P6_LABEL_36,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_43_1,
                    Principle6Key.P6_QUESTION_44_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_31
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_45,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_46,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_32
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_47,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_48,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_33
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_49,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_4
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_34
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_35
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_50,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_51,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_52,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_53,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_36
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_54,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_55,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_56,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_57,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_37
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_58,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_59,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_60,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_61,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_38
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_62,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_63,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_64,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_65,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_39
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_66,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_67,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_68,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_69,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_70,
                  fieldLabel: Principle6Label.P6_LABEL_60,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_50,
                    Principle6Key.P6_QUESTION_52,
                    Principle6Key.P6_QUESTION_54,
                    Principle6Key.P6_QUESTION_56,
                    Principle6Key.P6_QUESTION_58,
                    Principle6Key.P6_QUESTION_60,
                    Principle6Key.P6_QUESTION_62,
                    Principle6Key.P6_QUESTION_64,
                    Principle6Key.P6_QUESTION_66,
                    Principle6Key.P6_QUESTION_68
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_71,
                  fieldLabel: Principle6Label.P6_LABEL_61,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_51,
                    Principle6Key.P6_QUESTION_53,
                    Principle6Key.P6_QUESTION_55,
                    Principle6Key.P6_QUESTION_57,
                    Principle6Key.P6_QUESTION_59,
                    Principle6Key.P6_QUESTION_61,
                    Principle6Key.P6_QUESTION_63,
                    Principle6Key.P6_QUESTION_65,
                    Principle6Key.P6_QUESTION_67,
                    Principle6Key.P6_QUESTION_69
                  ],
                  formula: calculateSum
                }
              ]
            }
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_43
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_72,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_5
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle5Key.P5_QUESTION_73,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P6E_ZERO_LIQUID_DISCHARGE'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_44
          },
          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_74,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_75,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_76,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_45
          },
          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_77,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_78,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_79,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_46
          },
          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_80,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_81,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_82,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_47
          },
          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_83,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_84,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_85,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_48
          },
          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_86,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_87,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_88,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_49
          },

          {
            fieldType: inputType.SELECT,
            fieldName: Principle6Key.P6_QUESTION_89,
            fieldLabel: Principle6Label.P6_LABEL_3,
            options: [
              {label: 'MT', value: 'MT'},
              {label: 't/Kgs', value: 't/Kgs'},
              {label: 'g/kWh', value: 'g/kWh'},
              {label: 'kg/h', value: 'kg/h'}
            ]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_90,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_91,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_50
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'otherThanGHGEmissions',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_92_1,
                  fieldLabel: Principle6Label.P6_HEADING_50_1,
                  placeHolder: 'Other- Please Specify'
                },
                {
                  type: inputType.SELECT,
                  fieldName: Principle6Key.P6_QUESTION_92,
                  fieldLabel: Principle6Label.P6_LABEL_3,
                  options: [
                    {label: 'MT', value: 'MT'},
                    {label: 't/Kgs', value: 't/Kgs'},
                    {label: 'g/kWh', value: 'g/kWh'},
                    {label: 'kg/h', value: 'kg/h'}
                  ]
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_93,
                  fieldLabel: Principle6Label.P6_LABEL_1
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_94,
                  fieldLabel: Principle6Label.P6_LABEL_2
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_51
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_95,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_52
          },
          // {
          //   fieldType: inputType.SELECT,
          //   fieldName: Principle6Key.P6_QUESTION_96,
          //   fieldLabel: Principle6Label.P6_LABEL_3,
          //   options: [
          //     {
          //       label: 'Metric tonnes of CO2 equivalent',
          //       value: 'Metric tonnes of CO2 equivalent'
          //     }
          //   ]
          // },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_97,
            fieldLabel: Principle6Label.P6_LABEL_1,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_98,
            fieldLabel: Principle6Label.P6_LABEL_2,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_53
          },
          // {
          //   fieldType: inputType.SELECT,
          //   fieldName: Principle6Key.P6_QUESTION_99,
          //   fieldLabel: Principle6Label.P6_LABEL_3,
          //   options: [
          //     {
          //       label: 'Metric tonnes of CO2 equivalent',
          //       value: 'Metric tonnes of CO2 equivalent'
          //     }
          //   ]
          // },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_100,
            fieldLabel: Principle6Label.P6_LABEL_1,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_101,
            fieldLabel: Principle6Label.P6_LABEL_2,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_54
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_102,
                  fieldLabel: Principle6Label.P6_LABEL_6,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_103,
                  fieldLabel: Principle6Label.P6_LABEL_7
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_240,
                  fieldLabel: Principle6Label.P6_LABEL_38,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_102,
                    Principle6Key.P6_QUESTION_103
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_104,
                  fieldLabel: Principle6Label.P6_LABEL_6,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_105,
                  fieldLabel: Principle6Label.P6_LABEL_7
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_241,
                  fieldLabel: Principle6Label.P6_LABEL_39,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_104,
                    Principle6Key.P6_QUESTION_105
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_55
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_106,
                  fieldLabel: Principle6Label.P6_LABEL_6,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_107,
                  fieldLabel: Principle6Label.P6_LABEL_20
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_244,
                  fieldLabel: Principle6Label.P6_LABEL_40,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_106,
                    Principle6Key.P6_QUESTION_107
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_242,
                  fieldLabel: Principle6Label.P6_LABEL_6,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_243,
                  fieldLabel: Principle6Label.P6_LABEL_20
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_245,
                  fieldLabel: Principle6Label.P6_LABEL_41,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_242,
                    Principle6Key.P6_QUESTION_243
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_57
          },
          // {
          //   fieldType: inputType.SELECT,
          //   fieldName: Principle6Key.P6_QUESTION_113,
          //   fieldLabel: Principle6Label.P6_LABEL_3,
          //   options: [
          //     {
          //       label: 'Metric tonnes of CO2 equivalent',
          //       value: 'Metric tonnes of CO2 equivalent'
          //     }
          //   ]
          // },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_114,
            fieldLabel: Principle6Label.P6_LABEL_1,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_115,
            fieldLabel: Principle6Label.P6_LABEL_2,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_58
          },
          // {
          //   fieldType: inputType.SELECT,
          //   fieldName: Principle6Key.P6_QUESTION_116,
          //   fieldLabel: Principle6Label.P6_LABEL_3,
          //   options: [
          //     {
          //       label: 'Metric tonnes of CO2 equivalent',
          //       value: 'Metric tonnes of CO2 equivalent'
          //     }
          //   ]
          // },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_117,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_118,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true,
            units: Units.meticTonnesOfCO2Eq
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_59
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_119,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_8
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_120,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P6E_GHG_PROJECTS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_9
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_60
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_61
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_121,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_122,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_62
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_123,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_124,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_63
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_125,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_126,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_64
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_127,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_128,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_65
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_129,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_130,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_66
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_131,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_132,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_67
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_133_1,
                  placeHolder: 'Other- Please specify',
                  fieldLabel: Principle6Label.P6_LABEL_62,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_133,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_135,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_68
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_136_1,
                  placeHolder: 'Other- Please specify',
                  fieldLabel: Principle6Label.P6_LABEL_62,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_136,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_137,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_138,
                  fieldLabel: Principle6Label.P6_LABEL_42,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_121,
                    Principle6Key.P6_QUESTION_123,
                    Principle6Key.P6_QUESTION_125,
                    Principle6Key.P6_QUESTION_127,
                    Principle6Key.P6_QUESTION_129,
                    Principle6Key.P6_QUESTION_131,
                    Principle6Key.P6_QUESTION_133,
                    Principle6Key.P6_QUESTION_136
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_139,
                  fieldLabel: Principle6Label.P6_LABEL_43,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_122,
                    Principle6Key.P6_QUESTION_124,
                    Principle6Key.P6_QUESTION_126,
                    Principle6Key.P6_QUESTION_128,
                    Principle6Key.P6_QUESTION_130,
                    Principle6Key.P6_QUESTION_132,
                    Principle6Key.P6_QUESTION_135,
                    Principle6Key.P6_QUESTION_137
                  ],
                  formula: calculateSum
                }
              ]
            }
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_70
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_140,
                  fieldLabel: Principle6Label.P6_LABEL_9,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_141,
                  fieldLabel: Principle6Label.P6_LABEL_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_370,
                  fieldLabel: Principle6Label.P6_LABEL_48,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_140,
                    Principle6Key.P6_QUESTION_141
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_142,
                  fieldLabel: Principle6Label.P6_LABEL_9,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_142_1,
                  fieldLabel: Principle6Label.P6_LABEL_10
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_371,
                  fieldLabel: Principle6Label.P6_LABEL_49,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_142,
                    Principle6Key.P6_QUESTION_142_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_71
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_143,
                  fieldLabel: Principle6Label.P6_LABEL_9,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_144,
                  fieldLabel: Principle6Label.P6_LABEL_11
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_383,
                  fieldLabel: Principle6Label.P6_LABEL_50,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_143,
                    Principle6Key.P6_QUESTION_144
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_145,
                  fieldLabel: Principle6Label.P6_LABEL_9,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_145_1,
                  fieldLabel: Principle6Label.P6_LABEL_11
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_384,
                  fieldLabel: Principle6Label.P6_LABEL_51,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_145,
                    Principle6Key.P6_QUESTION_145_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_72
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_146,
            fieldLabel: Principle6Label.P6_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_147,
            fieldLabel: Principle6Label.P6_LABEL_2
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_73
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_148,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_149,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_74
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_84
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_75
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_150,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_151,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_76
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_152,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_153,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_77
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_154,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_155,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_156,
                  fieldLabel: Principle6Label.P6_LABEL_44,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_150,
                    Principle6Key.P6_QUESTION_152,
                    Principle6Key.P6_QUESTION_154
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_157,
                  fieldLabel: Principle6Label.P6_LABEL_45,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_151,
                    Principle6Key.P6_QUESTION_153,
                    Principle6Key.P6_QUESTION_155
                  ],
                  formula: calculateSum
                }
              ]
            }
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_78
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_79
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_158,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_159,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_80
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_160,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_161,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_81
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_162_1,
                  fieldLabel: Principle6Label.P6_LABEL_62,
                  placeHolder: 'Others - please specify'
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_162,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.metricTonsUnit
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle6Key.P6_QUESTION_163,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.metricTonsUnit
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_164,
                  fieldLabel: Principle6Label.P6_LABEL_46,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_158,
                    Principle6Key.P6_QUESTION_160,
                    Principle6Key.P6_QUESTION_162
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_165,
                  fieldLabel: Principle6Label.P6_LABEL_47,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_159,
                    Principle6Key.P6_QUESTION_161,
                    Principle6Key.P6_QUESTION_163
                  ],
                  formula: calculateSum
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_82
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_166,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_10
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_167,
            askAIkey: 'P6E_WASTE_MANAGEMENT'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_11
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_167_1,
            fieldLabel: Principle6Label.P6_LABEL_12
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle6Key.P6_QUESTION_380,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_168,
                  fieldLabel: Principle6Label.P6_HEADING_85,
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_169,
                  fieldLabel: Principle6Label.P6_HEADING_86,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP_IF_NO_THEN_TEXTBOX,
                  fieldName: Principle6Key.P6_QUESTION_170,
                  fieldLabel: Principle6Label.P6_HEADING_87,
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_12
          },

          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_170_1,
            fieldLabel: Principle6Label.P6_LABEL_12
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle6Key.P6_QUESTION_381,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_171,
                  fieldLabel: Principle6Label.P6_HEADING_88,
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_172,
                  fieldLabel: Principle6Label.P6_HEADING_89,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName: Principle6Key.P6_QUESTION_173,
                  fieldLabel: Principle6Label.P6_HEADING_90,
                  dateFormat: 'DD-MM-YYYY',
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle6Key.P6_QUESTION_174,
                  fieldLabel: Principle6Label.P6_HEADING_91,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle6Key.P6_QUESTION_175,
                  fieldLabel: Principle6Label.P6_HEADING_92,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_176,
                  fieldLabel: Principle6Label.P6_HEADING_93,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_13
          },
          {
            fieldType: inputType.RADIOGROUP_NO_THEN_SHOW_TABLE,
            fieldName: Principle6Key.P6_QUESTION_177,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            type: inputType.TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_177_value,
            colSpan: true
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS_TOGGLE_TABLE,
            relatedKey: Principle6Key.P6_QUESTION_177,
            fieldName: Principle6Key.P6_QUESTION_177_1,
            triggerKey: 'No',
            formList: {
              name: 'entityCompliant',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_178,
                  fieldLabel: Principle6Label.P6_HEADING_94,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_179,
                  fieldLabel: Principle6Label.P6_HEADING_95,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_180,
                  fieldLabel: Principle6Label.P6_HEADING_96,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_181,
                  fieldLabel: Principle6Label.P6_HEADING_97,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle6Label.P6_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_14
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_3
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_99
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_182
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_100
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_183
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_101
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle6Label.P6_HEADING_21
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_184,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_185,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_23
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_186,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_187,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_188,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_189,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_25
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_190,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_191,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_26
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_192_1,
                  placeHolder: 'Other- Please specify'
                },
                {
                  type: inputType.HEADING,
                  heading: ''
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_192,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_193,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_194,
                  fieldLabel: Principle6Label.P6_LABEL_52,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_184,
                    Principle6Key.P6_QUESTION_186,
                    Principle6Key.P6_QUESTION_188,
                    Principle6Key.P6_QUESTION_190,
                    Principle6Key.P6_QUESTION_192
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_195,
                  fieldLabel: Principle6Label.P6_LABEL_53,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_185,
                    Principle6Key.P6_QUESTION_187,
                    Principle6Key.P6_QUESTION_189,
                    Principle6Key.P6_QUESTION_191,
                    Principle6Key.P6_QUESTION_193
                  ],
                  formula: calculateSum
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_102
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_196,
            fieldLabel: Principle6Label.P6_LABEL_1,
            units: Units.kiloLitres
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_197,
            fieldLabel: Principle6Label.P6_LABEL_2,
            units: Units.kiloLitres
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_103
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_198,
                  fieldLabel: Principle6Label.P6_LABEL_13,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_199,
                  fieldLabel: Principle6Label.P6_LABEL_14
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_372,
                  fieldLabel: Principle6Label.P6_LABEL_54,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_198,
                    Principle6Key.P6_QUESTION_199
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_198_1,
                  fieldLabel: Principle6Label.P6_LABEL_13,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_199_1,
                  fieldLabel: Principle6Label.P6_LABEL_14
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_373,
                  fieldLabel: Principle6Label.P6_LABEL_55,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_198_1,
                    Principle6Key.P6_QUESTION_199_1
                  ],
                  formula: ([consumption, rupees]: any[]): string | number => {
                    return consumption / rupees;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_32
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle6Key.P6_QUESTION_200,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true
          },
          {
            fieldType: inputType.TEXT,
            fieldName: Principle6Key.P6_QUESTION_201,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_HEADING_34
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_35
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_202,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_203,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_204,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_205,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_36
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_206,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_207,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_208,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_209,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_37
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_210,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_211,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_212,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_213,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_38
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_214,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_215,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_216,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_217,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_39
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle6Key.P6_QUESTION_218_1,
                  placeHolder: 'Other- Please specify'
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_218,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_219,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_220,
                  fieldLabel: Principle6Label.P6_LABEL_1,
                  units: Units.kiloLitres
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_221,
                  fieldLabel: Principle6Label.P6_LABEL_2,
                  units: Units.kiloLitres
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_222,
                  fieldLabel: Principle6Label.P6_LABEL_56,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_202,
                    Principle6Key.P6_QUESTION_204,
                    Principle6Key.P6_QUESTION_206,
                    Principle6Key.P6_QUESTION_208,
                    Principle6Key.P6_QUESTION_210,
                    Principle6Key.P6_QUESTION_212,
                    Principle6Key.P6_QUESTION_214,
                    Principle6Key.P6_QUESTION_216,
                    Principle6Key.P6_QUESTION_218,
                    Principle6Key.P6_QUESTION_220
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_223,
                  fieldLabel: Principle6Label.P6_LABEL_57,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_203,
                    Principle6Key.P6_QUESTION_205,
                    Principle6Key.P6_QUESTION_207,
                    Principle6Key.P6_QUESTION_209,
                    Principle6Key.P6_QUESTION_211,
                    Principle6Key.P6_QUESTION_213,
                    Principle6Key.P6_QUESTION_215,
                    Principle6Key.P6_QUESTION_217,
                    Principle6Key.P6_QUESTION_219,
                    Principle6Key.P6_QUESTION_221
                  ],
                  formula: calculateSum
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_43
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_224,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_15
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_104
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                // {
                //   type: inputType.SELECT,
                //   fieldName: Principle6Key.P6_QUESTION_225,
                //   fieldLabel: Principle6Label.P6_LABEL_3,
                //   options: [
                //     {
                //       label: 'Metric tonnes of CO2 equivalent',
                //       value: 'Metric tonnes of CO2 equivalent'
                //     }
                //   ]
                // },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_226,
                  fieldLabel: Principle6Label.P6_LABEL_63,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_228,
                  fieldLabel: Principle6Label.P6_LABEL_5
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_248,
                  fieldLabel: Principle6Label.P6_LABEL_58,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_226,
                    Principle6Key.P6_QUESTION_228
                  ],
                  formula: ([emissions, turnover]: any[]): string | number => {
                    return emissions / turnover;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                // {
                //   type: inputType.HEADING,
                //   heading: Principle6Label.P6_HEADING_105
                // },
                {
                  type: inputType.HEADING,
                  heading: Principle6Label.P6_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_227,
                  fieldLabel: Principle6Label.P6_LABEL_63,
                  units: Units.meticTonnesOfCO2Eq
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle6Key.P6_QUESTION_229,
                  fieldLabel: Principle6Label.P6_LABEL_5
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: Principle6Key.P6_QUESTION_249,
                  fieldLabel: Principle6Label.P6_LABEL_59,
                  relatedKey: [
                    Principle6Key.P6_QUESTION_227,
                    Principle6Key.P6_QUESTION_229
                  ],
                  formula: ([emissions, turnover]: any[]): string | number => {
                    return emissions / turnover;
                  }
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_106
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_230,
            fieldLabel: Principle6Label.P6_LABEL_1,
            smallText: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle6Key.P6_QUESTION_231,
            fieldLabel: Principle6Label.P6_LABEL_2,
            smallText: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle6Label.P6_HEADING_107
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_232,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_16
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_233,
            askAIkey: 'P6L_BIODIVERSITY_IMPACT'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_17
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle6Key.P6_QUESTION_382,
            formList: {
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_234,
                  fieldLabel: Principle6Label.P6_HEADING_108,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_235,
                  fieldLabel: Principle6Label.P6_HEADING_109,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle6Key.P6_QUESTION_236,
                  fieldLabel: Principle6Label.P6_HEADING_110,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_18
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_237,
            askAIkey: 'P6L_BCP_DMP'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_19
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle6Key.P6_QUESTION_238,
            askAIkey: 'P6L_ENV_VALUE_CHAIN_IMPACT'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle6Label.P6_QUESTION_20
          },

          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle6Key.P6_QUESTION_239,
            units: Units.percentage
          }
        ]
      }
    ]
  }
];

export const principle7TabQuestions = [
  {
    key: '1',
    label: Principle7Label.P7_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle7Label.P7_QUESTION_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle7Key.P7_QUESTION_1,
            askAIkey: 'P7E_TRADE_ASSOCIATIONS'
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle7Label.P7_QUESTION_2
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle7Key.P7_QUESTION_81,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle7Key.P7_QUESTION_2,
                  fieldLabel: Principle7Label.P7_HEADING_6,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName: Principle7Key.P7_QUESTION_3,
                  fieldLabel: Principle7Label.P7_HEADING_7,
                  options: [
                    {label: 'State', value: 'State'},
                    {label: 'National', value: 'National'}
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: Principle7Label.P7_QUESTION_3
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle7Key.P7_QUESTION_21,
            fieldLabel: Principle7Label.P7_LABEL_13
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle7Key.P7_QUESTION_82,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle7Key.P7_QUESTION_22,
                  fieldLabel: Principle7Label.P7_HEADING_8,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle7Key.P7_QUESTION_23,
                  fieldLabel: Principle7Label.P7_HEADING_9,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle7Key.P7_QUESTION_24,
                  fieldLabel: Principle7Label.P7_HEADING_10,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle7Label.P7_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: Principle7Label.P7_QUESTION_4
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle7Key.P7_QUESTION_83,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle7Key.P7_QUESTION_25,
                  fieldLabel: Principle7Label.P7_HEADING_11,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle7Key.P7_QUESTION_26,
                  fieldLabel: Principle7Label.P7_HEADING_12,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle7Key.P7_QUESTION_27,
                  fieldLabel: Principle7Label.P7_HEADING_13,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle7Key.P7_QUESTION_28,
                  fieldLabel: Principle7Label.P7_HEADING_14,
                  options: ['Annually', 'Half yearly', 'Quarterly', 'Other'],
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle7Key.P7_QUESTION_29,
                  fieldLabel: Principle7Label.P7_HEADING_15,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const principle8TabQuestions = [
  {
    key: '1',
    label: Principle8Label.P8_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_1
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle8Key.P8_QUESTION_1_1,
            fieldLabel: Principle8Label.P8_LABEL_3
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_81,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_1,
                  fieldLabel: Principle8Label.P8_HEADING_6,
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_2,
                  fieldLabel: Principle8Label.P8_HEADING_7,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName: Principle8Key.P8_QUESTION_3,
                  fieldLabel: Principle8Label.P8_HEADING_8,
                  restrictFutureDateSelection: true,
                  dateFormat: 'DD-MM-YYYY',
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle8Key.P8_QUESTION_4,
                  fieldLabel: Principle8Label.P8_HEADING_9,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle8Key.P8_QUESTION_5,
                  fieldLabel: Principle8Label.P8_HEADING_10,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_6,
                  fieldLabel: Principle8Label.P8_HEADING_11,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_2
          },
          {
            fieldType: inputType.CHECKBOX_NA_THEN_TEXTAREA,
            fieldName: Principle8Key.P8_QUESTION_7_1,
            fieldLabel: Principle8Label.P8_LABEL_3
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_82,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_7,
                  fieldLabel: Principle8Label.P8_HEADING_12,
                  colSpan: true
                },
                {
                  type: inputType.STATE,
                  fieldName: Principle8Key.P8_QUESTION_8,
                  fieldLabel: Principle8Label.P8_HEADING_13,
                  relatedKey: Principle8Key.P8_QUESTION_9,
                  colSpan: true
                },
                {
                  type: inputType.CITY,
                  fieldName: Principle8Key.P8_QUESTION_9,
                  fieldLabel: Principle8Label.P8_HEADING_14,
                  relatedKey: Principle8Key.P8_QUESTION_8,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle8Key.P8_QUESTION_10,
                  fieldLabel: Principle8Label.P8_HEADING_15,
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle8Key.P8_QUESTION_11,
                  fieldLabel: Principle8Label.P8_HEADING_16,
                  units: Units.percentage,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle8Key.P8_QUESTION_12,
                  fieldLabel: Principle8Label.P8_HEADING_17,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_3
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle8Key.P8_QUESTION_13,
            askAIkey: 'P8E_COMMUNITY_GRIEVANCES'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_18
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle8Key.P8_QUESTION_14_1,
            fieldLabel: Principle8Label.P8_LABEL_3
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_14,
            fieldLabel: Principle8Label.P8_LABEL_1,
            relatedKey: Principle8Key.P8_QUESTION_14_1,
            disabledOn: true,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_15,
            fieldLabel: Principle8Label.P8_LABEL_2,
            relatedKey: Principle8Key.P8_QUESTION_14_1,
            disabledOn: true,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_19
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle8Key.P8_QUESTION_16_1,
            fieldLabel: Principle8Label.P8_LABEL_3
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_16,
            fieldLabel: Principle8Label.P8_LABEL_1,
            relatedKey: Principle8Key.P8_QUESTION_16_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_17,
            fieldLabel: Principle8Label.P8_LABEL_2,
            relatedKey: Principle8Key.P8_QUESTION_16_1,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_5
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_HEADING_25
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_20
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_18,
            fieldLabel: Principle8Label.P8_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_19,
            fieldLabel: Principle8Label.P8_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_21
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_20,
            fieldLabel: Principle8Label.P8_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_21,
            fieldLabel: Principle8Label.P8_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_22
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_22,
            fieldLabel: Principle8Label.P8_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_23,
            fieldLabel: Principle8Label.P8_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_23
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_24,
            fieldLabel: Principle8Label.P8_LABEL_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle8Key.P8_QUESTION_25,
            fieldLabel: Principle8Label.P8_LABEL_2,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_HEADING_24
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle8Label.P8_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_6
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_83,
            formList: {
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle8Key.P8_QUESTION_25,
                  fieldLabel: Principle8Label.P8_HEADING_26,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle8Key.P8_QUESTION_26,
                  fieldLabel: Principle8Label.P8_HEADING_27,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_7
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_84,
            formList: {
              formFields: [
                {
                  type: inputType.STATE,
                  fieldName: Principle8Key.P8_QUESTION_27,
                  fieldLabel: Principle8Label.P8_HEADING_28,
                  relatedKey: Principle8Key.P8_QUESTION_28,
                  colSpan: true
                },
                {
                  type: inputType.CITY,
                  fieldName: Principle8Key.P8_QUESTION_28,
                  fieldLabel: Principle8Label.P8_HEADING_29,
                  relatedKey: Principle8Key.P8_QUESTION_27,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle8Key.P8_QUESTION_29,
                  fieldLabel: Principle8Label.P8_HEADING_30,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_8
          },

          {
            fieldType: inputType.RADIOGROUP,
            fieldName: Principle8Key.P8_QUESTION_30,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_42
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle7Key.P7_QUESTION_31_1,
            fieldLabel: Principle7Label.P7_LABEL_13
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle8Key.P8_QUESTION_31
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle8Label.P8_HEADING_43
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle7Key.P7_QUESTION_32_1,
            fieldLabel: Principle7Label.P7_LABEL_13
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle8Key.P8_QUESTION_32
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_9
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_85,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_33,
                  fieldLabel: Principle8Label.P8_HEADING_31,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle8Key.P8_QUESTION_34,
                  fieldLabel: Principle8Label.P8_HEADING_32,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: Principle8Key.P8_QUESTION_35,
                  fieldLabel: Principle8Label.P8_HEADING_33,
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle8Key.P8_QUESTION_36,
                  fieldLabel: Principle8Label.P8_HEADING_34,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_10
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_86,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_37,
                  fieldLabel: Principle8Label.P8_HEADING_35,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle8Key.P8_QUESTION_38,
                  fieldLabel: Principle8Label.P8_HEADING_36,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName: Principle8Key.P8_QUESTION_39,
                  fieldLabel: Principle8Label.P8_HEADING_37,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle8Label.P8_QUESTION_11
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: Principle8Key.P8_QUESTION_87,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: Principle8Key.P8_QUESTION_40,
                  fieldLabel: Principle8Label.P8_HEADING_38,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName: Principle8Key.P8_QUESTION_41,
                  fieldLabel: Principle8Label.P8_HEADING_39,
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: Principle8Key.P8_QUESTION_42,
                  fieldLabel: Principle8Label.P8_HEADING_40,
                  units: Units.percentage,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const principle9TabQuestions = [
  {
    key: '1',
    label: Principle9Label.P9_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_1
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_43,
            askAIkey: 'P9E_CONSUMER_FEEDBACK'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_2
          },

          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_6
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle9Key.P9_QUESTION_44_1,
            fieldLabel: Principle9Label.P9_LABEL_9,
            relatedKey: Principle9Key.P9_QUESTION_44
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle9Key.P9_QUESTION_44,
            fieldLabel: Principle9Label.P9_LABEL_3,
            relatedKey: Principle9Key.P9_QUESTION_44_1,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_7
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle9Key.P9_QUESTION_45_1,
            fieldLabel: Principle9Label.P9_LABEL_9
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle9Key.P9_QUESTION_45,
            fieldLabel: Principle9Label.P9_LABEL_3,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_8
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: Principle9Key.P9_QUESTION_46_1,
            fieldLabel: Principle9Label.P9_LABEL_9
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle9Key.P9_QUESTION_46,
            fieldLabel: Principle9Label.P9_LABEL_3,
            units: Units.percentage
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_3
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_9
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_47,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_48,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_49,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_50,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_51,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_52,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_10
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_53,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_54,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_55,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_56,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_57,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_58,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_11
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_59,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_60,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_61,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_62,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_63,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_64,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_12
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_65,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_66,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_67,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_68,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_69,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_70,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_13
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_71,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_72,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_73,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_74,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_75,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_76,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_14
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_77,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_78,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_79,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_80,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_81,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_82,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING_3,
                  heading: Principle9Label.P9_HEADING_15
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_83,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_84,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_85,
                  fieldLabel: Principle9Label.P9_LABEL_6
                },
                {
                  type: inputType.HEADING,
                  heading: Principle9Label.P9_HEADING_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_86,
                  fieldLabel: Principle9Label.P9_LABEL_4
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: Principle9Key.P9_QUESTION_87,
                  fieldLabel: Principle9Label.P9_LABEL_5
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName: Principle9Key.P9_QUESTION_88,
                  fieldLabel: Principle9Label.P9_LABEL_6
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_4
          },

          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle9Key.P9_QUESTION_89,
            fieldLabel: Principle9Label.P9_LABEL_7
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_90,
            fieldLabel: Principle9Label.P9_LABEL_8,
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_HEADING_17
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle9Key.P9_QUESTION_91,
            fieldLabel: Principle9Label.P9_LABEL_7
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_92,
            fieldLabel: Principle9Label.P9_LABEL_8,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_5
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_93,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P9E_CYBER_POLICY'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_6
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_94,
            askAIkey: 'P9E_CORRECTIVE_ACTIONS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: Principle9Key.P9_QUESTION_95
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_19
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: Principle9Key.P9_QUESTION_96,
            units: Units.percentage
          },
          {
            fieldType: inputType.HEADING,
            heading: Principle9Label.P9_HEADING_20
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_97,
            askAIkey: 'P9E_DATA_BREACHES'
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: Principle9Label.P9_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_8
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_98,
            askAIkey: 'P9L_PRODUCT_INFO_CHANNELS'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_9
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_99,
            askAIkey: 'P9L_CONSUMER_EDUCATION'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_10
          },

          {
            fieldType: inputType.TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_100,
            askAIkey: 'P9L_SERVICE_DISRUPTION_INFO'
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: Principle9Label.P9_QUESTION_11
          },
          {
            fieldType: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
            fieldName: Principle9Key.P9_QUESTION_101,
            options: ['Yes', 'No'],
            colSpan: true,
            askAIkey: 'P9L_PRODUCT_INFO_DISPLAY'
          }
        ]
      }
    ]
  }
];
